webpackJsonp([1],{

/***/ "+4Ht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};


var FallbackPage = /** @class */function (_super) {
    __extends(FallbackPage, _super);
    function FallbackPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FallbackPage = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({})], FallbackPage);
    return FallbackPage;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (FallbackPage);

/***/ }),

/***/ "/psz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};


var Tabs = /** @class */function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tabs.prototype.onTabChange = function (path) {
        this.$emit('onTabChanged', path);
    };
    Tabs = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
        props: ['tabs', 'currentTab']
    })], Tabs);
    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),

/***/ "0lZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiService; });
/* unused harmony export SingleDataOperations */
/* unused harmony export AnalysisOperations */
// NB! this file should be generated using `gradlew generateApi`
var ApiService = /** @class */function () {
    function ApiService(api) {
        this.api = api;
        this.singleData = new SingleDataOperations(this.api);
        this.analysis = new AnalysisOperations(this.api);
    }
    return ApiService;
}();

var SingleDataOperations = /** @class */function () {
    function SingleDataOperations(api) {
        this.api = api;
    }
    SingleDataOperations.prototype.getFrontBubbleData = function () {
        return this.api.execute("getFrontBubbleData", {});
    };
    SingleDataOperations.prototype.getSingleData = function (request) {
        return this.api.execute("getSingleData", request);
    };
    return SingleDataOperations;
}();

var AnalysisOperations = /** @class */function () {
    function AnalysisOperations(api) {
        this.api = api;
    }
    AnalysisOperations.prototype.echo = function (request) {
        return this.api.execute("echo", request);
    };
    AnalysisOperations.prototype.getGraphData = function (request) {
        return this.api.execute("getGraphData", request);
    };
    return AnalysisOperations;
}();


/***/ }),

/***/ "25eS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a8a7cdcec9ebc966c18755bf5b4f6a76.svg";

/***/ }),

/***/ "2U8y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getXData */
/* unused harmony export getYData */
/* unused harmony export fixLabels */
/* unused harmony export fixOrder */
/* unused harmony export getPercentageDiff */
/* unused harmony export getPercentagShift */
/* unused harmony export getPercent */
/* unused harmony export getChartObjInPercentage */
/* unused harmony export getChartObjLimited */
/* unused harmony export getChartObj */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPackage; });
/* unused harmony export limitToFive */
/* unused harmony export getRange */
/* unused harmony export getGrowth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addInterest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPercentage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_models__ = __webpack_require__("cqHW");

var __assign = this && this.__assign || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

var getXData = function getXData(data, xKey, yKey) {
    return data.reduce(function (acc, curr) {
        var accLabel = acc.filter(function (item) {
            return item['label'] === curr[xKey];
        })[0];
        if (accLabel) {
            accLabel['total'] += curr[yKey];
        } else {
            acc.push({
                label: curr[xKey],
                total: +curr[yKey]
            });
        }
        return acc;
    }, []);
};
var getYData = function getYData(data, x, xKey, yKey, stackKey) {
    return data.reduce(function (acc, curr) {
        var slotIndex = x.map(function (item) {
            return item['label'];
        }).indexOf(curr[xKey]); // x slot index [2013, 2014, 2015, X-2016-X, 2017]
        var yKeyName = stackKey ? curr[stackKey] : yKey;
        var arr = acc.filter(function (item) {
            return item[0] === yKeyName;
        })[0];
        if (!arr) {
            acc.push([yKeyName].concat(Array(x.length).fill(0)));
            arr = acc[acc.length - 1];
        }
        arr[slotIndex + 1] += curr[yKey];
        return acc;
    }, []) // [label, val, val, val]
    ;
};
var fixLabels = function fixLabels(chartData, type) {
    switch (type) {
        case 'sugu':
            return chartData.map(function (item) {
                if (item[0] === 'M' || item[0] === 1) {
                    item[0] = 'Mehed';
                    return item;
                }
                if (item[0] === 'N' || item[0] === 2) {
                    item[0] = 'Naised';
                    return item;
                }
            });
        case 'vanus':
            return chartData.map(function (item) {
                if (item[0] === '-18') {
                    item[0] = 'Kuni 18 a.';
                } else {
                    item[0] = item[0] + ' a.';
                }
                return item;
            });
        case 'vanuseGrupp':
            return chartData.map(function (item) {
                if (item[0] === '-18') {
                    item[0] = 'Kuni 18 a.';
                } else {
                    item[0] = item[0] + ' a.';
                }
                return item;
            });
        case 'tulugrupp':
            return chartData.map(function (item) {
                if (item[0] === '-300') {
                    item[0] = '<300 €';
                } else {
                    item[0] = item[0] + ' €';
                }
                return item;
            });
        case 'sihtotstarve':
            return chartData.map(function (item) {
                item[0] = item[0].split(' (')[0];
                return item;
            });
        default:
            return chartData;
    }
};
var fixOrder = function fixOrder(chartData, type) {
    switch (type) {
        case 'vanus':
            return chartData.sort(function (a, b) {
                return !b[0] ? 1 : a[0] > b[0] ? 1 : b[0] > a[0] ? -1 : 0;
            });
        case 'vanuseGrupp':
            return chartData.sort(function (a, b) {
                return !b[0] ? 1 : a[0] > b[0] ? 1 : b[0] > a[0] ? -1 : 0;
            });
        case 'tulugrupp':
            return chartData.sort(function (a, b) {
                var a2 = a[0].split('-')[0];
                var b2 = b[0].split('-')[0];
                return !+b2 ? 1 : +a2 > +b2 ? 1 : +b2 > +a2 ? -1 : 0;
            });
        case 'aasta':
            return chartData.sort(function (a, b) {
                return !b['aasta'] ? 1 : a['aasta'] > b['aasta'] ? 1 : b['aasta'] > a['aasta'] ? -1 : 0;
            });
        case 'seisuAasta':
            return chartData.sort(function (a, b) {
                return !b['seisuAasta'] ? 1 : a['seisuAasta'] > b['seisuAasta'] ? 1 : b['seisuAasta'] > a['seisuAasta'] ? -1 : 0;
            });
        default:
            return chartData;
    }
};
var getPercentageDiff = function getPercentageDiff(oldVal, newVal) {
    return 1 - (oldVal - newVal) / oldVal;
};
var getPercentagShift = function getPercentagShift(oldVal, newVal) {
    return -(oldVal - newVal) / oldVal;
};
var getPercent = function getPercent(from, val) {
    return val / from * 100;
};
var getChartObjInPercentage = function getChartObjInPercentage(x, yData) {
    return yData.map(function (item) {
        return item.map(function (subItem, index) {
            return index > 0 ? getPercentageDiff(x[index - 1].total, subItem) : subItem;
        });
    });
};
var getChartObjLimited = function getChartObjLimited(x, yData, limit) {
    var xTotal = x.reduce(function (acc, curr) {
        if (curr) {
            acc += curr.total;
        }
        return acc;
    }, 0);
    var isEqualAboveLimitData = yData.filter(function (item) {
        var yTotal = item.reduce(function (acc, curr, i) {
            if (i === 0) {
                return acc;
            } // skip label
            if (curr) {
                acc += curr;
            }
            return acc;
        }, 0);
        return getPercent(xTotal, yTotal) >= limit ? true : false;
    });
    var isBelowLimitData = yData.filter(function (item) {
        var yTotal = item.reduce(function (acc, curr, i) {
            if (i === 0) {
                return acc;
            } // skip label
            if (curr) {
                acc += curr;
            }
            return acc;
        }, 0);
        return getPercent(xTotal, yTotal) < limit ? true : false;
    });
    var isBelowDataObj = isBelowLimitData.reduce(function (acc, curr) {
        curr.map(function (item, i) {
            if (i === 0) {
                acc[i] = 'Muu';
                return;
            }
            if (item) {
                if (acc[i]) {
                    acc[i] += item;
                } else {
                    acc[i] = item;
                }
            }
        });
        return acc;
    }, []);
    return isEqualAboveLimitData.concat([isBelowDataObj]);
};
var getChartObj = function getChartObj(data, x, y, viewType, graphName) {
    // Modifiers
    var yFormat = Array.isArray(y.format) ? y.format[viewType] : y.format;
    // ORDERBY PreData
    if (x.label === 'aasta') {
        data = fixOrder(data, 'aasta');
    }
    if (x.label === 'seisuAasta') {
        data = fixOrder(data, 'seisuAasta');
    }
    // PreData => ChartData
    var xData = getXData(data, x.label, y.label);
    var yData = getYData(data, xData, x.label, y.label, y.group);
    // ORDERBY ChartData
    if (y.group && y.group === 'vanus') {
        yData = fixOrder(yData, 'vanus');
    } // Age groups: Fix order
    if (y.group && y.group === 'vanuseGrupp') {
        yData = fixOrder(yData, 'vanuseGrupp');
    } // Age groups: Fix order
    if (y.group && y.group === 'tulugrupp') {
        yData = fixOrder(yData, 'tulugrupp');
    } // salary groups: Fix order
    // RENAME ChartData
    if (y.group === 'sugu') {
        yData = fixLabels(yData, 'sugu');
    } // Gender: fix labels for display
    if (y.group && y.group === 'vanus') {
        yData = fixLabels(yData, 'vanus');
    } // Age groups: Fix -18 label for display
    if (y.group && y.group === 'vanuseGrupp') {
        yData = fixLabels(yData, 'vanuseGrupp');
    }
    if (y.group && y.group === 'tulugrupp') {
        yData = fixLabels(yData, 'tulugrupp');
    }
    if (y.group && y.group === 'sihtotstarve') {
        yData = fixLabels(yData, 'sihtotstarve');
    }
    if (x.label === 'aasta' || x.label === 'seisuAasta') {
        xData.map(function (item) {
            return item.label = item.label + ' a.';
        });
    } // Add a.
    // Mutations
    if (y.limit) {
        yData = getChartObjLimited(xData, yData, y.limit);
    } // merge smaller objects
    if (yFormat === __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE) {
        yData = getChartObjInPercentage(xData, yData);
    } // Convert values into percentages
    if (y.renameLabel) {
        yData[0][0] = y.renameLabel;
    }
    // return { xData, yData, yFormat }
    return {
        x: xData,
        y: {
            data: yData,
            format: yFormat,
            stacked: true,
            type: 'bar'
        }
    };
};
var getPackage = function getPackage(barData, lineData, config, viewType, graphName) {
    var main = getChartObj(barData, config.x, config.y, viewType, graphName);
    var second;
    if (config.y2 && main.y.format !== __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE) {
        if (Array.isArray(config.y2)) {
            second = config.y2.reduce(function (acc, curr) {
                acc.push(getChartObj(lineData, config.x, curr, viewType, graphName));
                return acc;
            }, []).reduce(function (acc, curr) {
                acc.y.data = acc.y.data.concat(curr.y.data);
                acc.y.format = curr.y.format;
                return acc;
            }, { y: { data: [] } });
            if (graphName === 'tulude-laekumine-ajas') {
                second.y.options = { fromZero: true };
            }
            if (graphName === 'tulude-laekumine-ajas-tax') {
                second.y.options = { fromZero: true };
            }
            if (graphName === 'tulude-potentsiaalne-laekumine' || graphName === 'tulude-jaotus-summa') {
                second.y.options = { fromZero: true };
            }
        } else {
            second = getChartObj(lineData, config.x, config.y2, viewType, graphName);
        }
    }
    switch (graphName) {
        case 'tulubaas':
            if (main.y.format !== __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE) {
                second = {
                    y: {
                        data: [getGrowth('Tulubaasi kasv', main.x)],
                        format: __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE,
                        stacked: true,
                        type: 'line'
                    }
                };
            }
            break;
        case 'maksutulud':
            if (main.y.format !== __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE) {
                second = {
                    y: {
                        data: [getGrowth('Maksutulu kasv', main.x)],
                        format: __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE,
                        stacked: true,
                        type: 'line'
                    }
                };
            }
            break;
        case 'toohoive-asukoht':
            main.y.stacked = false;
            break;
    }
    if (main.x.length === 1 && main.y.format === __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].PERCENTAGE) {
        main.y.type = 'pie';
    }
    // Limit output to five
    var y2 = second ? second.y : { data: [], format: __WEBPACK_IMPORTED_MODULE_1__chart_models__["a" /* FormatNameValues */].NULL, type: 'line', stacked: true };
    var limitedXData = limitToFive('x', main.x);
    var limitedYData = limitToFive('y', main.y.data);
    var limitedY2Data = limitToFive('y', y2.data);
    // return ({
    //     x: main.x,
    //     y: main.y,
    //     y2: (second) ? second.y : { data: [], format: FormatNameValues.NULL, type: 'line', stacked: true }
    // });
    return {
        x: limitedXData,
        y: __assign({}, main.y, { data: limitedYData }),
        y2: __assign({}, y2, { data: limitedY2Data })
    };
};
var limitToFive = function limitToFive(type, data) {
    switch (type) {
        case 'x':
            // if(data.length <= 5) return data;
            return data.slice(Math.max(data.length - 5, 0));
        case 'y':
        case 'y2':
            if (!data.length) {
                return data;
            }
            return data.map(function (subdata) {
                return [subdata[0]].concat(subdata.slice(Math.max(subdata.length - 5, 1)));
            });
            ;
    }
};
/* Additional  */
var getRange = function getRange(data, key) {
    return data.reduce(function (acc, curr) {
        if (acc.indexOf(curr[key]) === -1) {
            acc.push(curr[key]);
        }
        return acc;
    }, []);
};
var getGrowth = function getGrowth(key, x) {
    var inPercentage = [];
    for (var i = 0; i < x.length; i++) {
        if (i === 0) {
            inPercentage[i] = 0;
        } else {
            inPercentage[i] = getPercentagShift(x[i - 1]['total'], x[i]['total']);
        }
    }
    // avoid negative incorrect percantages when year is still ongoing
    var currYear = new Date().getFullYear().toString();
    if (x[x.length - 1].label.indexOf(currYear) !== -1) {
        inPercentage[inPercentage.length - 1] = null;
    }
    return [key].concat(inPercentage);
};
/* Pot. FIT Methods */
var addInterest = function addInterest(curr, percent) {
    return +(curr * (1 + percent / 100)).toFixed(2);
};
var getPercentage = function getPercentage(sum, percent) {
    return +(sum * (percent / 100));
};

/***/ }),

/***/ "2fBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectbox_vue__ = __webpack_require__("e1wJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a2a368_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectbox_vue__ = __webpack_require__("iPh2");
function injectStyle (ssrContext) {
  __webpack_require__("MaEi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50a2a368"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a2a368_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2rxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__ = __webpack_require__("/psz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c994c73e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__("Liyt");
function injectStyle (ssrContext) {
  __webpack_require__("LI1e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c994c73e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c994c73e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4tRb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1bcd9a944635f01136b4cd7974b6e884.svg";

/***/ }),

/***/ "6ywT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77N4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EnumPatternBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphNameValues; });
/* unused harmony export SingleDataNameValues */
/** base class for implementing enums with Typesafe Enum Pattern (to be able to use enum names, instead of ordinal values, in a type-safe manner) */
var EnumPatternBase = /** @class */function () {
    function EnumPatternBase(name) {
        this.name = name;
    }
    EnumPatternBase.prototype.toString = function () {
        return this.name;
    };
    return EnumPatternBase;
}();

var GraphNameValues;
(function (GraphNameValues) {
    GraphNameValues.DIVIDENDI_TULU_SAAJAID_ARVULISELT = 'DIVIDENDI_TULU_SAAJAID_ARVULISELT';
    GraphNameValues.DIVIDENDI_TULU_ÜLDISELT = 'DIVIDENDI_TULU_ÜLDISELT';
    GraphNameValues.EMTAK2_PÕHINE = 'EMTAK2_PÕHINE';
    GraphNameValues.INIMESED_VANUSERÜHMITI = 'INIMESED_VANUSERÜHMITI';
    GraphNameValues.INIMESTE_ARVU_MUUTUS_AJAS = 'INIMESTE_ARVU_MUUTUS_AJAS';
    GraphNameValues.MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL = 'MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL';
    GraphNameValues.MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL = 'MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL';
    GraphNameValues.SISSE_VÄLJA_REGISTREERIMISED = 'SISSE_VÄLJA_REGISTREERIMISED';
    GraphNameValues.TOP10_ASUKOHA_PÕHINE = 'TOP10_ASUKOHA_PÕHINE';
    GraphNameValues.TULUBAASI_KASV = 'TULUBAASI_KASV';
    GraphNameValues.TULUDE_LAEKUMINE_PALGAGRUPITI = 'TULUDE_LAEKUMINE_PALGAGRUPITI';
    GraphNameValues.TULUDE_LAEKUMINE_VANUSERÜHMITI = 'TULUDE_LAEKUMINE_VANUSERÜHMITI';
    GraphNameValues.TULUDE_LAEKUMISE_SUMMA = 'TULUDE_LAEKUMISE_SUMMA';
    GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA = 'TULU_SUMMA_KÜLADE_KAUPA';
    GraphNameValues.TÖÖTAMISE_ASUKOHT = 'TÖÖTAMISE_ASUKOHT';
    GraphNameValues.ÜLDINE_TULUDE_LAEKUMINE = 'ÜLDINE_TULUDE_LAEKUMINE';
    GraphNameValues.ÜLDISELT_TÖÖTAVAD_INIMESED = 'ÜLDISELT_TÖÖTAVAD_INIMESED';
})(GraphNameValues || (GraphNameValues = {}));
var SingleDataNameValues;
(function (SingleDataNameValues) {
    SingleDataNameValues.DIVIDENDI_TULU_VIIMANE_TÄIS_AASTA = 'DIVIDENDI_TULU_VIIMANE_TÄIS_AASTA';
})(SingleDataNameValues || (SingleDataNameValues = {}));

/***/ }),

/***/ "7R4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__ = __webpack_require__("EOM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_generated_api_service__ = __webpack_require__("0lZF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_api_client__ = __webpack_require__("tqXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_generated_api_types__ = __webpack_require__("77N4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_chart_methods__ = __webpack_require__("2U8y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__core_localData__ = __webpack_require__("N+LA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chart_vue__ = __webpack_require__("plmt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_radiobox_vue__ = __webpack_require__("lxHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_checkbox_vue__ = __webpack_require__("ne3v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_selectbox_vue__ = __webpack_require__("2fBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_tabs_vue__ = __webpack_require__("2rxR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chart_header_vue__ = __webpack_require__("KFZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3__ = __webpack_require__("Za4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_html2canvas__ = __webpack_require__("2Pnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_downloadjs__);










var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && (g[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default.a] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};

















var Graph = /** @class */function (_super) {
    __extends(Graph, _super);
    function Graph() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new __WEBPACK_IMPORTED_MODULE_13__api_generated_api_service__["a" /* ApiService */](new __WEBPACK_IMPORTED_MODULE_14__api_api_client__["a" /* ApiClient */]());
        _this.villages = __WEBPACK_IMPORTED_MODULE_17__core_localData__["c" /* VillageData */]['viimsi'];
        _this.sections = __WEBPACK_IMPORTED_MODULE_17__core_localData__["b" /* SectionData */];
        _this.settings = Object(__WEBPACK_IMPORTED_MODULE_17__core_localData__["d" /* getGraphSettings */])();
        _this.chartConfig = null;
        _this.graphSelector = [];
        _this.toohoiveLocations = Object(__WEBPACK_IMPORTED_MODULE_17__core_localData__["d" /* getGraphSettings */])('tulude-laekumine-palgagrupiti').uiConfig.customRadio;
        _this.registreerimisedView = Object(__WEBPACK_IMPORTED_MODULE_17__core_localData__["d" /* getGraphSettings */])('demograafilised-andmed-registreeritud').uiConfig.customRadio;
        _this.registreerimised = Object(__WEBPACK_IMPORTED_MODULE_17__core_localData__["d" /* getGraphSettings */])('demograafilised-andmed-registreeritud').uiConfig.customCheck;
        _this.dividends = [{ label: 'Pot. dividenditulud', value: 'Pot. dividenditulud' }];
        _this.selected = {
            gender: 0,
            viewType: 0,
            registreerimisedView: _this.registreerimisedView[0],
            toohoiveLocationsSelected: _this.toohoiveLocations.slice(),
            registreerimisedSelected: _this.registreerimised.slice(),
            dividendsSelected: []
        };
        _this.data = {};
        _this.SelectedFIT = {
            income: {
                countIncrease: 20,
                percentIncrease: 2
            },
            dividend: {
                taxPercent: 2,
                percentIncrease: 5
            }
        };
        _this.showLocation = false;
        _this.selectedLocation = 'viimsiValdJaMujalBrutotuludKokku';
        return _this;
    }
    Object.defineProperty(Graph.prototype, "getAreaFromUrl", {
        get: function get() {
            return this.$route.params.area;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Graph.prototype, "getVillageFromUrl", {
        get: function get() {
            var _this = this;
            return this.villages.find(function (village) {
                return _this.$route.params.village === village.value;
            }) || { name: 'Kokku', value: 'kokku' };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Graph.prototype, "getSectionFromUrl", {
        get: function get() {
            var _this = this;
            return this.sections.find(function (section) {
                return _this.$route.params.section === section.value;
            }) || this.sections[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Graph.prototype, "getGraphNameFromUrl", {
        get: function get() {
            return this.$route.params.graphName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Graph.prototype, "isMobile", {
        get: function get() {
            return window.outerWidth < 768;
        } // only check during component render

        , enumerable: true,
        configurable: true
    });
    Graph.prototype.mounted = function () {
        if (this.isMobile && 'orientation' in screen) {
            screen.orientation.lock('landscape');
        }
        this.genChart();
    };
    Graph.prototype.destroyed = function () {
        if ('orientation' in screen) {
            screen.orientation.unlock();
        }
    };
    Graph.prototype.routeChanged = function (newVal, oldVal) {
        this.selected.gender = this.selected.viewType = 0;
        this.selected.toohoiveLocationsSelected = this.toohoiveLocations.slice();
        this.selected.registreerimisedSelected = this.registreerimised.slice();
        this.genChart();
    };
    Graph.prototype.genChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var graphValue, settings, barData, lineData, _a, filteredBarData, filteredLineData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        graphValue = this.getGraphNameFromUrl;
                        if (this.getGraphNameFromUrl === 'fit') {
                            this.genFITChart();
                            return [2 /*return*/];
                        }
                        settings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17__core_localData__["d" /* getGraphSettings */])(graphValue));
                        this.settings = this.getProcessedSettings(settings, graphValue);
                        this.graphSelector = this.settings.uiConfig.graphSelector ? this.settings.uiConfig.graphSelector : []; // find a better way
                        return [4 /*yield*/, this.getData(this.settings.y.graphName)];
                    case 1:
                        barData = _b.sent();
                        if (!this.settings.y2) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getData(this.settings.y2[0].graphName)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = null;
                        _b.label = 4;
                    case 4:
                        lineData = _a;
                        filteredBarData = this.getFilteredBarData(barData, graphValue, this.selected);
                        filteredLineData = this.getFilteredLineData(lineData, graphValue, this.selected);
                        this.chartConfig = Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["b" /* getPackage */])(filteredBarData, filteredLineData, this.settings, this.selected.viewType, graphValue);
                        return [2 /*return*/];
                }
            });
        });
    };
    Graph.prototype.genFITChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var graphValue, settings, barData, incomeTaxData, dividendTaxData, yearLatest, incomeTaxDataLatestYearObj, baseIncomeTaxObj, estimatedIncometaxArr, dividendTaxDataLatestYearObj, baseDividendTaxObj, estimatedDividendtaxArr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        graphValue = this.getGraphNameFromUrl;
                        settings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17__core_localData__["d" /* getGraphSettings */])(graphValue));
                        this.settings = this.getProcessedSettings(settings, graphValue);
                        barData = [];
                        return [4 /*yield*/, this.getData(__WEBPACK_IMPORTED_MODULE_15__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMISE_SUMMA)];
                    case 1:
                        incomeTaxData = _a.sent();
                        return [4 /*yield*/, this.getData(__WEBPACK_IMPORTED_MODULE_15__api_generated_api_types__["a" /* GraphNameValues */].DIVIDENDI_TULU_ÜLDISELT)];
                    case 2:
                        dividendTaxData = _a.sent();
                        yearLatest = incomeTaxData.sort(function (a, b) {
                            return !b['aasta'] ? 1 : a['aasta'] > b['aasta'] ? 1 : b['aasta'] > a['aasta'] ? -1 : 0;
                        })[incomeTaxData.length - 1]['aasta'];
                        incomeTaxDataLatestYearObj = incomeTaxData.filter(function (item) {
                            return item['aasta'] === yearLatest;
                        });
                        baseIncomeTaxObj = this.getFITBaseIncomeTaxObj(incomeTaxDataLatestYearObj);
                        estimatedIncometaxArr = this.genFITEstimatedIncomeTaxArr(baseIncomeTaxObj, 4);
                        barData = [baseIncomeTaxObj].concat(estimatedIncometaxArr);
                        if (this.selected.dividendsSelected.length) {
                            dividendTaxDataLatestYearObj = dividendTaxData.filter(function (item) {
                                return item['aasta'] === yearLatest;
                            });
                            baseDividendTaxObj = this.getFITBaseDividendTaxObj(dividendTaxDataLatestYearObj);
                            estimatedDividendtaxArr = this.genFITEstimatedDividendTaxArr(baseDividendTaxObj, 4);
                            barData = barData.concat([baseDividendTaxObj], estimatedDividendtaxArr);
                        }
                        this.chartConfig = Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["b" /* getPackage */])(barData, [], settings, this.selected.viewType, graphValue);
                        return [2 /*return*/];
                }
            });
        });
    };
    Graph.prototype.getData = function (graphName) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.data[graphName]) {
                            return [2 /*return*/, this.data[graphName]];
                        }
                        return [4 /*yield*/, this.api.analysis.getGraphData({ graphName: graphName })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, this.data[graphName] = res.data];
                }
            });
        });
    };
    Graph.prototype.getProcessedSettings = function (settings, graphValue) {
        switch (graphValue) {
            case 'tulude-jaotus-arv':
                if (!this.selected.dividendsSelected.length && Array.isArray(settings.y2)) {
                    settings.y2 = settings.y2.filter(function (item) {
                        return item.label !== 'dividenditulu2';
                    });
                }
                break;
            case 'tulude-jaotus-summa':
                if (!this.selected.dividendsSelected.length && Array.isArray(settings.y2)) {
                    settings.y2 = settings.y2.filter(function (item) {
                        return item.label !== 'dividenditulu2';
                    });
                }
                break;
            default:
                break;
        }
        return settings;
    };
    Graph.prototype.getFilteredBarData = function (data, graphValue, selected) {
        var _this = this;
        if (selected.gender !== 0 && (graphValue === 'demograafilised-andmed' || graphValue === 'demograafilised-andmed-vanus')) {
            var genderChar_1 = selected.gender === 1 ? 'M' : 'N';
            data = data.filter(function (item) {
                return genderChar_1 === item['sugu'];
            });
        } else if (selected.gender !== 0) {
            data = data.filter(function (item) {
                return selected.gender === item['sugu'];
            });
        }
        switch (graphValue) {
            case 'maksutulud':
                return data.filter(function (item) {
                    return item['tüüp'] === 'Maksutulud';
                });
            case 'toohoive-asukoht':
                var selected_1 = this.selected.toohoiveLocationsSelected.map(function (item) {
                    return item.value;
                });
                return data.filter(function (item) {
                    return selected_1.indexOf(item['asukohaGrupp']) !== -1;
                });
            case 'tulude-laekumine-palgagrupiti':
                data = data.map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { brutotuludKokku: item[_this.selectedLocation] });
                });
                return data;
            case 'demograafilised-andmed-registreeritud':
                var key_1 = this.selected.registreerimisedView.value;
                if (key_1 === 'uuedRegistreerunudInimesed' && this.selected.registreerimisedSelected.length === 1) {
                    key_1 = this.selected.registreerimisedSelected[0].value;
                }
                data = data.map(function (item) {
                    item['inimesed'] = item[key_1];
                    return item;
                });
                return data;
            case 'tulude-jaotus-summa':
                var refined = data.reduce(function (acc, curr) {
                    var aasta = curr.aasta,
                        asukohtAl10 = curr.asukohtAl10,
                        dividendiTulu = curr.dividendiTulu,
                        palgaTulu = curr.palgaTulu,
                        palgatulu1116 = curr.palgatulu1116,
                        dividenditulu2 = curr.dividenditulu2;
                    var tootasu = { aasta: aasta, asukohtAl10: asukohtAl10, summa: palgaTulu, type: 'Palgatulu', palgatulu1116: palgatulu1116, dividenditulu2: dividenditulu2 }; //palgatulu1116 & dividenditulu2 - for y2
                    var dividend = { aasta: aasta, asukohtAl10: asukohtAl10, summa: dividendiTulu || 0, type: 'Dividenditulu' }; //do not include palgatulu1116 & dividenditulu2 .. will be doubled
                    acc = acc.concat([tootasu, dividend]);
                    return acc;
                }, []);
                if (this.getVillageFromUrl.value === 'kokku') {
                    return refined;
                }
                return refined.filter(function (item) {
                    return item['asukohtAl10'] === _this.getVillageFromUrl.name;
                });
            case 'tulude-jaotus-arv':
                var arvRefined = data.reduce(function (acc, curr) {
                    var aasta = curr.aasta,
                        asukohtAl10 = curr.asukohtAl10,
                        isikuteArvDividendiTulu = curr.isikuteArvDividendiTulu,
                        isikuteArvPalgaTulu = curr.isikuteArvPalgaTulu,
                        isikuteArvPalgaJaDividendiTulu = curr.isikuteArvPalgaJaDividendiTulu,
                        palgatulu1116 = curr.palgatulu1116,
                        dividenditulu2 = curr.dividenditulu2;
                    var arvDividend = { aasta: aasta, asukohtAl10: asukohtAl10, summa: isikuteArvDividendiTulu || 0, type: 'Dividenditulu saajate arv', palgatulu1116: palgatulu1116, dividenditulu2: dividenditulu2 }; //palgatulu1116 & dividenditulu2 - for y2
                    var arvPalk = { aasta: aasta, asukohtAl10: asukohtAl10, summa: isikuteArvPalgaTulu || 0, type: 'Palgatulu saajate arv' };
                    var arvPalkDividend = { aasta: aasta, asukohtAl10: asukohtAl10, summa: isikuteArvPalgaJaDividendiTulu || 0, type: 'Palga ja dividendi saajate arv' };
                    acc = acc.concat([arvDividend, arvPalk, arvPalkDividend]);
                    return acc;
                }, []);
                if (this.getVillageFromUrl.value === 'kokku') {
                    return arvRefined;
                }
                return arvRefined.filter(function (item) {
                    return item['asukohtAl10'] === _this.getVillageFromUrl.name;
                });
            default:
                return data;
        }
    };
    Graph.prototype.getFilteredLineData = function (data, graphValue, selected) {
        var _this = this;
        if (!data) return data;
        switch (graphValue) {
            case 'tulubaas':
                // console.log(data)
                return data;
            case 'maksutulud':
                // console.log(data)
                return data;
            case 'toohoive':
                return selected.gender === 0 ? data : data.filter(function (item) {
                    return selected.gender === item['sugu'];
                });
            case 'tulude-jaotus-summa':
                if (this.getVillageFromUrl.value === 'kokku') {
                    return data;
                }
                return data.filter(function (item) {
                    return item['asukohtAl10'] === _this.getVillageFromUrl.name;
                });
            case 'tulude-jaotus-arv':
                if (this.getVillageFromUrl.value === 'kokku') {
                    return data;
                }
                return data.filter(function (item) {
                    return item['asukohtAl10'] === _this.getVillageFromUrl.name;
                });
        }
        return data;
    };
    Graph.prototype.downloadGraphImage = function () {
        var _this = this;
        try {
            this.sendGAEvent('Graph', 'click', 'Download image', this.settings.title);
            var style_1 = "\n";
            var availableStyleSheets = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(document.styleSheets).map(function (key) {
                return document.styleSheets[key];
            }).filter(function (sheet) {
                return !sheet.href || sheet.href.indexOf(window.location.hostname) !== -1;
            });
            // get available styles that are associated with c3
            availableStyleSheets.forEach(function (sheet) {
                if (sheet.cssRules) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sheet.cssRules).map(function (key) {
                        return sheet.cssRules[key];
                    }).forEach(function (rule) {
                        if (rule.selectorText && rule.selectorText.indexOf('c3') !== -1) {
                            style_1 += rule.cssText + '\n';
                        }
                    });
                }
            });
            var charts_1 = __WEBPACK_IMPORTED_MODULE_24_d3___default.a.select('.charts'),
                chartsNode = charts_1.node();
            // TODO when html2canvas starts supporting onclone(https://github.com/niklasvh/html2canvas/issues/1403) again, then use cloned document to set all this
            charts_1.select('.legend-list').classed('legend-list--show-all', true); // show all legends
            charts_1.select('.chart__content svg').classed('c3', true).insert('defs', ':first-child');
            charts_1.select('.chart__content svg defs').append('style').attr('type', 'text/css').html(style_1); // apply styles
            __WEBPACK_IMPORTED_MODULE_25_html2canvas___default()(chartsNode, {
                allowTaint: true,
                useCORS: true,
                foreignObjectRendering: false,
                width: chartsNode.offsetWidth,
                height: chartsNode.offsetHeight,
                x: chartsNode.offsetLeft,
                y: chartsNode.offsetTop,
                scrollY: chartsNode.scrollY,
                scrollX: chartsNode.scrollX,
                logging: false
            }).then(function (canvas) {
                __WEBPACK_IMPORTED_MODULE_26_downloadjs___default()(canvas.toDataURL('image/png'), _this.settings.title + ".png", 'image/png'); // download file
                charts_1.select('.chart__content svg defs').remove(); // remove styles again
                charts_1.select('.legend-list').classed('legend-list--show-all', false); // hide all legends again
            });
        } catch (error) {
            alert('Graafiku pildi allalaadimiseks kasuta palun värskemat veebilehitseja tehnoloogiat - nt Google Chrome, Mozilla Firefox, Microsoft Edge või Safari.');
        }
    };
    Graph.prototype.onViewTypeChanged = function (viewType) {
        this.selected.viewType = viewType;
        this.genChart();
    };
    Graph.prototype.onRegisterViewTypeChanged = function (view) {
        this.selected.registreerimisedView = this.registreerimisedView.filter(function (item) {
            return item.value === view;
        })[0];
        this.genChart();
    };
    Graph.prototype.onregistreerimisedChanged = function (event) {
        if (this.selected.registreerimisedSelected.length === 0) {
            setTimeout(function () {
                return event.target.click();
            }, 0);
        }
        this.genChart();
    };
    Graph.prototype.onGenderChanged = function (gender) {
        this.selected.gender = +gender;
        this.genChart();
    };
    Graph.prototype.onToohoiveLocationChanged = function (event) {
        if (this.selected.toohoiveLocationsSelected.length === 0) {
            setTimeout(function () {
                return event.target.click();
            }, 0);
        }
        this.genChart();
    };
    Graph.prototype.onLocationChanged = function (location) {
        this.sendGAEvent('Graph', 'change', 'Location', location);
        this.selectedLocation = location;
        this.genChart();
    };
    Graph.prototype.onSectionChanged = function (section) {
        this.sendGAEvent('Graph', 'change', 'Section', section);
        this.$router.replace("/graphs/" + this.getAreaFromUrl + "/kokku/" + section.value + "/" + section.defaultGraphName);
    };
    Graph.prototype.onGraphChanged = function (graphName) {
        this.sendGAEvent('Graph', 'change', 'Graph', graphName);
        if (this.getSectionFromUrl.value === 'tulude-jaotus') {
            this.$router.replace("/graphs/" + this.getAreaFromUrl + "/" + this.getVillageFromUrl.value + "/" + this.getSectionFromUrl.value + "/" + graphName);
        } else {
            this.$router.replace("/graphs/" + this.getAreaFromUrl + "/kokku/" + this.getSectionFromUrl.value + "/" + graphName);
        }
    };
    Graph.prototype.onVillageChanged = function (village) {
        this.sendGAEvent('Graph', 'change', 'Village', village);
        this.$router.replace("/graphs/" + this.getAreaFromUrl + "/" + village.value + "/" + this.getSectionFromUrl.value + "/" + this.getGraphNameFromUrl);
    };
    Graph.prototype.onDividendChanged = function () {
        this.genChart();
    };
    Graph.prototype.getFITFormValues = function (submitEvent) {
        this.SelectedFIT.income.countIncrease = +submitEvent.target.elements.count.value.replace(/,/g, '.');
        this.SelectedFIT.income.percentIncrease = +submitEvent.target.elements.percent.value.replace(/,/g, '.');
        this.SelectedFIT.dividend.percentIncrease = 5;
        this.genChart();
    };
    Graph.prototype.getFITBaseIncomeTaxObj = function (apiData) {
        return apiData.reduce(function (acc, curr) {
            if (!acc.tax) {
                acc = {
                    tax: curr['brutotulust116'],
                    people: curr['grupisIsikuid'],
                    year: curr['aasta'],
                    gender: 0,
                    ageGroup: null,
                    type: 'FIT',
                    taxPerPerson: 0,
                    income: 0
                };
            } else {
                acc.tax += curr['brutotulust116'];
                acc.people += curr['grupisIsikuid'];
                acc.taxPerPerson = acc.tax / acc.people;
            }
            return acc;
        }, {});
    };
    Graph.prototype.getFITBaseDividendTaxObj = function (apiData) {
        var _this = this;
        return apiData.reduce(function (acc, curr) {
            if (!acc.tax) {
                acc = {
                    tax: Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["c" /* getPercentage */])(curr['dividendideSumma'], _this.SelectedFIT.dividend.taxPercent),
                    year: curr['aasta'],
                    gender: 0,
                    income: curr['dividendideSumma'],
                    type: 'Dividend',
                    taxPerPerson: 0
                };
            } else {
                acc.income += curr['dividendideSumma'];
                acc.tax += Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["c" /* getPercentage */])(curr['dividendideSumma'], _this.SelectedFIT.dividend.taxPercent);
            }
            return acc;
        }, {});
    };
    Graph.prototype.genFITEstimatedIncomeTaxArr = function (_a, steps) {
        var _this = this;
        var people = _a.people,
            tax = _a.tax,
            taxPerPerson = _a.taxPerPerson,
            year = _a.year,
            gender = _a.gender;
        return Array(steps).fill(undefined).map(function (item) {
            year += 1;
            people += _this.SelectedFIT.income.countIncrease;
            taxPerPerson = Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["a" /* addInterest */])(taxPerPerson, _this.SelectedFIT.income.percentIncrease);
            tax = taxPerPerson * people;
            return { tax: tax, taxPerPerson: taxPerPerson, people: people, year: year, gender: gender, ageGroup: null, type: 'FIT', income: 0 };
        });
    };
    Graph.prototype.genFITEstimatedDividendTaxArr = function (_a, steps) {
        var _this = this;
        var year = _a.year,
            income = _a.income,
            tax = _a.tax,
            gender = _a.gender;
        return Array(steps).fill(undefined).map(function (item) {
            year += 1;
            income = Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["a" /* addInterest */])(income, _this.SelectedFIT.dividend.percentIncrease);
            tax = Object(__WEBPACK_IMPORTED_MODULE_16__core_chart_methods__["a" /* addInterest */])(tax, _this.SelectedFIT.dividend.percentIncrease);
            return { gender: gender, income: income, tax: tax, year: year, type: 'Dividend', taxPerPerson: 0 };
        });
    };
    Graph.prototype.sendGAEvent = function (category, action, label, value) {
        var trackObj = {};
        if (category) trackObj.category = category;
        if (action) trackObj.action = action;
        if (label) trackObj.label = label;
        if (value) trackObj.value = value;
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].gtm.trackEvent(trackObj);
    };
    __decorate([Object(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__["Watch"])('$route')], Graph.prototype, "routeChanged", null);
    Graph = __decorate([__WEBPACK_IMPORTED_MODULE_11_vue_class_component___default()({
        components: {
            chartHeader: __WEBPACK_IMPORTED_MODULE_23__components_chart_header_vue__["a" /* default */],
            tabs: __WEBPACK_IMPORTED_MODULE_22__components_tabs_vue__["a" /* default */],
            chart: __WEBPACK_IMPORTED_MODULE_18__components_chart_vue__["a" /* default */],
            radiobox: __WEBPACK_IMPORTED_MODULE_19__components_radiobox_vue__["a" /* default */],
            checkbox: __WEBPACK_IMPORTED_MODULE_20__components_checkbox_vue__["a" /* default */],
            selectbox: __WEBPACK_IMPORTED_MODULE_21__components_selectbox_vue__["a" /* default */]
        }
    })], Graph);
    return Graph;
}(__WEBPACK_IMPORTED_MODULE_10_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (Graph);

/***/ }),

/***/ "877Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"chart",class:_vm.getGraphNameFromUrl},[_c('div',{staticClass:"chart__controller",class:{'chart__controller--wrap': _vm.wrapSettings}},[(_vm.slotValue && !_vm.slotAsLast)?_vm._t("default"):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGender),expression:"showGender"}],staticClass:"chart__settings"},[_c('radiobox',{attrs:{"name":"gender","label":"Kokku","value":"0","currentValue":_vm.gender},on:{"change":_vm.onGenderChanged}}),_vm._v(" "),_c('radiobox',{attrs:{"name":"gender","label":"Mehed","value":"1","currentValue":_vm.gender},on:{"change":_vm.onGenderChanged}}),_vm._v(" "),_c('radiobox',{attrs:{"name":"gender","label":"Naised","value":"2","currentValue":_vm.gender},on:{"change":_vm.onGenderChanged}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType),expression:"showType"}],staticClass:"chart__settings"},[_c('radiobox',{attrs:{"name":"type","label":"Arvuliselt","value":"0","currentValue":_vm.type},on:{"change":_vm.onTypeChanged}}),_vm._v(" "),_c('radiobox',{attrs:{"name":"type","label":"protsentuaalselt","value":"1","currentValue":_vm.type},on:{"change":_vm.onTypeChanged}})],1),_vm._v(" "),(_vm.slotValue && _vm.slotAsLast)?_vm._t("default"):_vm._e()],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"legend-list",class:{'legend-list--open': _vm.limitLegend !== 3}},_vm._l((_vm.legends),function(legend,index){return _c('li',{key:legend.label,staticClass:"legend-list__item",class:{'legend-list__item--visible': index < _vm.limitLegend}},[_c('a',{class:("legend-link legend-link--" + (legend.type)),attrs:{"href":"#"},on:{"mouseover":function($event){_vm.legendMouseOver(legend.label)},"mouseleave":function($event){_vm.legendMouseOut(legend.label)}}},[_c('span',{staticClass:"legend-link--ico",style:({ backgroundColor: legend.color })},[_c('span',{style:({ backgroundColor: legend.color })})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(legend.label))])])])})),_vm._v(" "),(_vm.legends.length > 3)?_c('p',{staticClass:"legend-toggler",class:{ 'legend-toggler--open': _vm.limitLegend !== 3 },attrs:{"data-html2canvas-ignore":""}},[_c('button',{staticClass:"legend-toggler__button",attrs:{"type":"button"},on:{"click":function($event){_vm.toggleLegendLimit()}}},[_vm._m(1),_vm._v(" "),_vm._m(2)])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart__content"},[_c('i',{staticClass:"el-icon-loading"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n                    Rohkem legende\n                    "),_c('i',{staticClass:"legend-toggler__icon el-icon-arrow-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n                    Vähem legende\n                    "),_c('i',{staticClass:"legend-toggler__icon el-icon-arrow-up"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9YiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graph_vue__ = __webpack_require__("7R4C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e659c360_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_graph_vue__ = __webpack_require__("Jazq");
function injectStyle (ssrContext) {
  __webpack_require__("dCQR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e659c360"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e659c360_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_graph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AlLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section landing"},[_c('section',{staticClass:"section__header landing__header"},[_c('h1',{staticClass:"landing__title"},[_vm._v("Viimsi valla tulud")]),_vm._v(" "),_c('div',{staticClass:"landing__search"},[_c('v-autocomplete',{attrs:{"items":_vm.queryOptions,"input-attrs":_vm.autocompleteInputAttrs,"get-label":_vm.getAutocompleteValueLabel,"component-item":_vm.autocompleteItemTemplate,"wait":0,"min-len":0,"auto-select-one-item":false},on:{"update-items":_vm.updateAutocomplete,"item-selected":_vm.onAutocompleteSelect}}),_vm._v(" "),_c('i',{staticClass:"landing__search-icon el-icon-search"})],1)]),_vm._v(" "),_c('section',{staticClass:"section__content"},[_c('div',{staticClass:"bubbles"},_vm._l((_vm.sortedBubbles),function(bubble){return _c('bubble',{key:bubble.id,attrs:{"bubble":bubble}})})),_vm._v(" "),_c('ul',{staticClass:"graph-list"},_vm._l((_vm.sortedBubbles),function(bubble){return _c('li',{key:bubble.priority},_vm._l((bubble.contents),function(content){return _c('div',{key:content.key,staticClass:"graph-list__item"},[_c('router-link',{staticClass:"graph-list__link",attrs:{"to":bubble.url},nativeOn:{"click":function($event){_vm.sendGAEvent('Landing', 'click', 'Dropdown click', bubble.url)}}},[_c('p',{staticClass:"graph-list__value"},[_vm._v(_vm._s(content.value))]),_vm._v(" "),_c('p',{staticClass:"graph-list__text"},[_vm._v(_vm._s(content.text))]),_vm._v(" "),_c('i',{staticClass:"graph-list__icon el-icon-arrow-right"})])],1)}))}))]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section__footer"},[_c('img',{staticClass:"section__footer-logo",attrs:{"src":__webpack_require__("4tRb"),"alt":"EU logo"}}),_vm._v(" "),_c('p',{staticClass:"section__footer-text"},[_vm._v("Projekt viidi ellu programmist \"Avalike teenuste koosvõime loomine\"")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B0qP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__("EOM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};



var BubbleElement = /** @class */function (_super) {
    __extends(BubbleElement, _super);
    function BubbleElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scaleAdjusted = false;
        _this.minimumTimePassed = false;
        _this.textWaitTime = 200;
        return _this;
    }
    // watch for changes in bubble and calculate the overflow
    BubbleElement.prototype.onBubbleChanged = function (val, oldVal) {
        this.$nextTick(this.calculateTextOverflow);
    };
    ;
    BubbleElement.prototype.mounted = function () {
        var _this = this;
        // wait a minimum time of 200ms before showing content
        setTimeout(function () {
            _this.minimumTimePassed = true;
        }, this.textWaitTime + 100 * this.bubble.priority);
    };
    /*
        Track event on bubble click
     */
    BubbleElement.prototype.bubbleClick = function (url) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].gtm.trackEvent({
            category: 'Landing',
            action: 'click',
            label: 'Bubble click',
            value: url
        });
    };
    /*
        When header or text overflows the bubble, then adjust it's scale so it would fit
     */
    BubbleElement.prototype.calculateTextOverflow = function () {
        if (this.bubble.contents[0].value) {
            var paddingSize = 50,
                bubbleSize = this.$refs.bubbleRef.clientWidth,
                headingSize = this.$refs.bubbleHeading.clientWidth + paddingSize,
                textSize = this.$refs.bubbleText.clientWidth + paddingSize;
            // check for heading overflow
            if (bubbleSize < headingSize) {
                this.$refs.bubbleHeading.style.transform = 'scale(' + bubbleSize / headingSize + ')';
            }
            // check for text overflow
            if (bubbleSize < textSize) {
                this.$refs.bubbleHeading.style.transform = 'scale(' + bubbleSize / textSize + ')';
            }
            this.scaleAdjusted = true;
        }
    };
    __decorate([Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('bubble', { immediate: true, deep: true })], BubbleElement.prototype, "onBubbleChanged", null);
    BubbleElement = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
        props: ['bubble']
    })], BubbleElement);
    return BubbleElement;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (BubbleElement);

/***/ }),

/***/ "Bx6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DncG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bubble_vue__ = __webpack_require__("VbKi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_v_autocomplete_item_vue__ = __webpack_require__("WElR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_localData__ = __webpack_require__("N+LA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_api_client__ = __webpack_require__("tqXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_generated_api_service__ = __webpack_require__("0lZF");






var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};







var Landing = /** @class */function (_super) {
    __extends(Landing, _super);
    function Landing() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new __WEBPACK_IMPORTED_MODULE_12__api_generated_api_service__["a" /* ApiService */](new __WEBPACK_IMPORTED_MODULE_11__api_api_client__["a" /* ApiClient */]());
        _this.autocompleteItemTemplate = __WEBPACK_IMPORTED_MODULE_9__components_v_autocomplete_item_vue__["a" /* default */];
        _this.autocompleteInputAttrs = { placeholder: 'Otsi tulubaasist' };
        _this.queryOptions = __WEBPACK_IMPORTED_MODULE_10__core_localData__["b" /* SectionData */].slice();
        _this.state = __WEBPACK_IMPORTED_MODULE_10__core_localData__["a" /* BubblesData */];
        return _this;
    }
    Landing.prototype.mounted = function () {
        this.getBubbles();
    };
    Object.defineProperty(Landing.prototype, "sortedBubbles", {
        /*
            Computed - sorted bubbles by priority
         */
        get: function get() {
            return this.state.sort(function (a, b) {
                return a['priority'] - b['priority'];
            });
        },
        enumerable: true,
        configurable: true
    });
    /*
        Return label for autocomplete input
     */
    Landing.prototype.getAutocompleteValueLabel = function (item) {
        return item ? item.name : '';
    };
    /*
        Filter autocomplete suggestion based on typed text
     */
    Landing.prototype.updateAutocomplete = function (text) {
        this.queryOptions = __WEBPACK_IMPORTED_MODULE_10__core_localData__["b" /* SectionData */].filter(function (option) {
            return option.name.toLowerCase().indexOf(text.toLowerCase()) !== -1;
        });
    };
    /*
        When user selects one of the values from dropdown
     */
    Landing.prototype.onAutocompleteSelect = function (item) {
        this.sendGAEvent('Landing', 'click', 'Dropdown click', item.defaultGraphName);
        this.$router.push("/graphs/viimsi/kokku/" + item.value + "/" + item.defaultGraphName);
    };
    Landing.prototype.sendGAEvent = function (category, action, label, value) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].gtm.trackEvent({
            category: category,
            action: action,
            label: label,
            value: value
        });
    };
    /*
        Get bubble data from API
     */
    Landing.prototype.getBubbles = function () {
        var _this = this;
        this.api.singleData.getFrontBubbleData().then(function (res) {
            _this.state = _this.updateState(res.frontBubbleData);
        });
    };
    Landing.prototype.updateState = function (newData) {
        var _this = this;
        var newState = this.state.map(function (bubble) {
            var contents = bubble.contents.map(function (content) {
                if (content.id) {
                    var value = newData[content.id] || '0';
                    if (value) {
                        var prettyValue = _this.prettifyBubbleValue(content.id, value);
                        return __assign({}, content, { value: prettyValue });
                    }
                    return __assign({}, content, { value: value });
                }
                return content;
            });
            return __assign({}, bubble, { contents: contents });
        });
        return newState;
    };
    Landing.prototype.prettifyBubbleValue = function (id, value) {
        var valueString = Math.floor(value).toString(),
            valueArray = valueString.split(/(?=(?:...)*$)/),
            valueStringGrouped = valueArray.length === 2 && valueArray[0].length === 1 ? valueArray.join('') : valueArray.join(' ');
        switch (id) {
            case 'tulubaas':
            case 'füüsiliseIsikuTulumaks':
                return valueString.length >= 6 ? (Math.round(Math.floor(value) / 1000000 * 10) / 10).toString().replace('.', ',') + " mln" : valueStringGrouped;
            case 'maksumaksjaid':
            case 'elanikeArv':
                return valueStringGrouped;
            case 'viimsiKeskmineBrutosissetulek':
            case 'potensiaalneDividendiTulumaks':
                return valueStringGrouped + "\u20AC";
            default:
                return value;
        }
    };
    Landing = __decorate([__WEBPACK_IMPORTED_MODULE_7_vue_class_component___default()({
        components: {
            bubble: __WEBPACK_IMPORTED_MODULE_8__components_bubble_vue__["a" /* default */]
        }
    })], Landing);
    return Landing;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (Landing);

/***/ }),

/***/ "E8ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["value", "val"],
    data: function data() {
        return {
            proxy: false
        };
    },

    computed: {
        checked: {
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.proxy = value;
            }
        }
    },
    methods: {
        onChange: function onChange(event) {
            this.$emit("input", this.proxy);
            this.$emit("clicked", event);
        }
    }
});

/***/ }),

/***/ "Jazq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section graphs"},[_c('section',{staticClass:"section__header graphs__header"},[_c('router-link',{staticClass:"graphs__header-link",class:{'graphs__header-link--wide': _vm.getSectionFromUrl.value === 'tulude-jaotus'},attrs:{"to":'/'},nativeOn:{"click":function($event){_vm.sendGAEvent('Graph', 'click', 'Back to frontpage')}}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v("\n            Esilehele\n        ")]),_vm._v(" "),_c('div',{staticClass:"selection graphs__selects"},[_c('div',{staticClass:"selection__container"},[_c('selectbox',{attrs:{"options":_vm.sections,"value":_vm.getSectionFromUrl},on:{"onSelectChanged":_vm.onSectionChanged}})],1),_vm._v(" "),(_vm.getSectionFromUrl.value === 'tulude-jaotus')?_c('div',{staticClass:"selection__container"},[_c('selectbox',{attrs:{"options":_vm.villages,"value":_vm.getVillageFromUrl},on:{"onSelectChanged":_vm.onVillageChanged}})],1):_vm._e()])],1),_vm._v(" "),_c('section',{staticClass:"section__content"},[_c('div',{staticClass:"charts"},[_c('div',{staticClass:"charts__settings"},[_c('tabs',{attrs:{"tabs":_vm.getSectionFromUrl.tabs,"currentTab":_vm.getGraphNameFromUrl},on:{"onTabChanged":_vm.onGraphChanged}})],1),_vm._v(" "),_c('chart-header',{attrs:{"title":_vm.settings.title,"description":_vm.settings.description}}),_vm._v(" "),(_vm.getGraphNameFromUrl === 'fit')?_c('div',{staticClass:"charts__settings"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.getFITFormValues($event)}}},[_vm._m(0)])]):_vm._e(),_vm._v(" "),_c('chart',{attrs:{"config":_vm.chartConfig,"showType":_vm.settings.uiConfig.format,"type":_vm.selected.viewType,"showGender":_vm.settings.uiConfig.gender,"gender":_vm.selected.gender,"wrapSettings":_vm.getSectionFromUrl.value === 'tulud-palgagrupiti' || _vm.getGraphNameFromUrl === 'demograafilised-andmed-registreeritud',"slotAsLast":_vm.getSectionFromUrl.value === 'tulud-palgagrupiti' || _vm.getGraphNameFromUrl === 'demograafilised-andmed-registreeritud'},on:{"onTypeChanged":_vm.onViewTypeChanged,"onGenderChanged":_vm.onGenderChanged}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.graphSelector.length),expression:"graphSelector.length"}],staticClass:"chart__settings"},_vm._l((_vm.graphSelector),function(radio){return _c('radiobox',{key:radio.value,attrs:{"name":"graphName","label":radio.label,"value":radio.value,"currentValue":_vm.getGraphNameFromUrl},on:{"change":_vm.onGraphChanged}})})),_vm._v(" "),(_vm.getGraphNameFromUrl === 'toohoive-asukoht')?_c('div',{staticClass:"chart__settings"},_vm._l((_vm.toohoiveLocations),function(option){return _c('checkbox',{key:option.label,attrs:{"val":option},on:{"clicked":_vm.onToohoiveLocationChanged},model:{value:(_vm.selected.toohoiveLocationsSelected),callback:function ($$v) {_vm.$set(_vm.selected, "toohoiveLocationsSelected", $$v)},expression:"selected.toohoiveLocationsSelected"}},[_vm._v(_vm._s(option.label))])})):_vm._e(),_vm._v(" "),(_vm.getGraphNameFromUrl === 'tulude-laekumine-palgagrupiti')?_c('div',{staticClass:"chart__settings chart__settings--wrap"},[_c('radiobox',{attrs:{"name":"location","label":"Viimsi vald ja mujal","value":"viimsiValdJaMujalBrutotuludKokku","currentValue":_vm.selectedLocation},on:{"change":_vm.onLocationChanged}}),_vm._v(" "),_c('radiobox',{attrs:{"name":"location","label":"Viimsi vald","value":"viimsiValdBrutotuludKokku","currentValue":_vm.selectedLocation},on:{"change":_vm.onLocationChanged}}),_vm._v(" "),_c('radiobox',{attrs:{"name":"location","label":"Mujal","value":"mujalBrutotuludKokku","currentValue":_vm.selectedLocation},on:{"change":_vm.onLocationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.getGraphNameFromUrl === 'demograafilised-andmed-registreeritud')?_c('div',{staticClass:"chart__settings chart__settings--no-separator"},_vm._l((_vm.registreerimisedView),function(radio){return _c('radiobox',{key:radio.value,attrs:{"name":"registreerimisedView","label":radio.label,"value":radio.value,"currentValue":_vm.selected.registreerimisedView.value},on:{"change":_vm.onRegisterViewTypeChanged}})})):_vm._e(),_vm._v(" "),(_vm.getGraphNameFromUrl === 'demograafilised-andmed-registreeritud' && (_vm.selected.registreerimisedView.value !== 'väljaRegistreerunud'))?_c('div',{staticClass:"chart__settings chart__settings--wrap"},_vm._l((_vm.registreerimised),function(option){return _c('checkbox',{key:option.label,attrs:{"val":option},on:{"clicked":_vm.onregistreerimisedChanged},model:{value:(_vm.selected.registreerimisedSelected),callback:function ($$v) {_vm.$set(_vm.selected, "registreerimisedSelected", $$v)},expression:"selected.registreerimisedSelected"}},[_vm._v(_vm._s(option.label))])})):_vm._e(),_vm._v(" "),(_vm.getSectionFromUrl.value === 'tulude-jaotus' || _vm.getGraphNameFromUrl === 'fit')?_c('div',{staticClass:"chart__settings"},_vm._l((_vm.dividends),function(option){return _c('checkbox',{key:option.label,attrs:{"val":option},on:{"clicked":_vm.onDividendChanged},model:{value:(_vm.selected.dividendsSelected),callback:function ($$v) {_vm.$set(_vm.selected, "dividendsSelected", $$v)},expression:"selected.dividendsSelected"}},[_vm._v(_vm._s(option.label))])})):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"downloads",attrs:{"data-html2canvas-ignore":""}},[_vm._v("\n            Laadi alla:\n            "),_c('ul',{staticClass:"downloads__list"},[_c('li',{staticClass:"downloads__item"},[_c('button',{staticClass:"downloads__link",attrs:{"type":"button"},on:{"click":function($event){_vm.downloadGraphImage()}}},[_vm._v("graafik")])]),_vm._v(" "),_c('li',{staticClass:"downloads__item"},[_c('a',{staticClass:"downloads__link",attrs:{"href":'/api/download/graphs/csv/' + _vm.settings.y.graphName,"download":_vm.settings.y.graphName},nativeOn:{"click":function($event){_vm.sendGAEvent('Graph', 'click', 'Download csv', _vm.settings.y.graphName)}}},[_vm._v("andmed")])]),_vm._v(" "),_c('li',{staticClass:"downloads__item"},[_c('a',{staticClass:"downloads__link",attrs:{"href":'mailto:info@viimsivv.ee'}},[_vm._v("info@viimsivv.ee")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('input',{staticClass:"field",attrs:{"name":"count","value":"20","type":"text"}}),_vm._v(" inimest\n                        "),_c('input',{staticClass:"field",attrs:{"name":"percent","value":"2","type":"text"}}),_vm._v(" %\n                        "),_c('button',{staticClass:"btn",attrs:{"type":"submit"}},[_vm._v("Arvuta")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KFZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_header_vue__ = __webpack_require__("uW5k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5407b8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_header_vue__ = __webpack_require__("VtMa");
function injectStyle (ssrContext) {
  __webpack_require__("zzif")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5407b8a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5407b8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LI1e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Liyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,staticClass:"tabs__item"},[_c('button',{staticClass:"tabs__link",class:{'tabs__link--active': _vm.currentTab === tab.value},attrs:{"type":"button"},on:{"click":function($event){_vm.onTabChange(tab.value)}}},[_vm._v(_vm._s(tab.title))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("arfo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98c099aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Bx6b");
function injectStyle (ssrContext) {
  __webpack_require__("vag9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98c099aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MaEi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+LA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatNameValues */
/* unused harmony export AreasData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VillageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGraphSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BubblesData; });
/* unused harmony export AgeGroups */
/* unused harmony export viewMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__ = __webpack_require__("77N4");

var FormatNameValues;
(function (FormatNameValues) {
    FormatNameValues.CURRENCY = 'currency';
    FormatNameValues.PERCENTAGE = 'percentage';
    FormatNameValues.PEOPLE = 'people';
    FormatNameValues.NULL = null;
})(FormatNameValues || (FormatNameValues = {}));
// areas data
var AreasData = [{
    name: 'Viimsi vald',
    value: 'viimsi'
}];
var VillageData = {
    viimsi: [{ name: 'Haabneeme alevik', value: 'Haabneeme' }, { name: 'Idaotsa küla', value: 'Idaotsa' }, { name: 'Kelnase küla', value: 'Kelnase' }, { name: 'Kelvingi küla', value: 'Kelvingi' }, { name: 'Laiaküla', value: 'Laiaküla' }, { name: 'Leppneeme küla', value: 'Leppneeme' }, { name: 'Lubja küla', value: 'Lubja' }, { name: 'Lääneotsa küla', value: 'Lääneotsa' }, { name: 'Metsakasti küla', value: 'Metsakasti' }, { name: 'Miiduranna küla', value: 'Miiduranna' }, { name: 'Muuga küla', value: 'Muuga' }, { name: 'Randvere küla', value: 'Randvere' }, { name: 'Rohuneeme küla', value: 'Rohuneeme' }, { name: 'Pringi küla', value: 'Pringi' }, { name: 'Pärnamäe küla', value: 'Pärnamäe' }, { name: 'Püünsi küla', value: 'Püünsi' }, { name: 'Tammneeme küla', value: 'Tammneeme' }, { name: 'Viimsi alevik', value: 'Viimsi' }, { name: 'Viimsi vald', value: 'Viimsi vald' }, { name: 'Viimsi vald kokku', value: 'kokku' }, { name: 'Äigrumäe küla', value: 'Äigrumäe' }, { name: 'Mujal', value: 'Mujal' }]
};
// section data
var SectionData = [{
    name: "Tulude üldine laekumine",
    title: "Tulude üldine laekumine",
    description: "Eelarve täitmine eelnenud kuu seisuga.",
    value: "tulud",
    defaultGraphName: "tulubaas"
}, {
    name: "Tulude laekumine ajas",
    title: "Tulude laekumine ajas",
    description: "",
    value: "tulud-ajas",
    defaultGraphName: "tulude-laekumine-ajas"
}, {
    name: "Tööhõive",
    title: "Brutosissetulek",
    value: "toohoive",
    defaultGraphName: "toohoive",
    tabs: [{
        title: 'Brutosissetulek',
        description: 'Inimeste arv või osakaal töötasu vahemikes',
        value: 'toohoive'
    }, {
        title: 'Töötamise asukoht',
        description: '',
        value: 'toohoive-asukoht'
    }, {
        title: 'Viimsilaste töökohad',
        description: '',
        value: 'toohoive-top'
    }, {
        title: 'Viimsilaste töövaldkonnad',
        description: '',
        value: 'toohoive-emtak'
    }]
}, {
    name: "Tulud palgagrupiti",
    title: "Tulud tööandja asukoha põhiselt",
    description: "Töötamise asukoha põhised andmed on kättesaadavad alates 2017. a.",
    value: "tulud-palgagrupiti",
    defaultGraphName: "tulude-laekumine-vanuseruhmiti"
}, {
    name: "Võimalikud tuluallikad",
    title: "Võimalikud tuluallikad",
    value: "tulude-potentsiaal",
    defaultGraphName: "tulude-potentsiaalne-laekumine",
    tabs: [{
        title: 'Dividenditulu',
        graphTitle: 'Viimsi elanikele makstud dividendid*',
        description: '*Vastavalt seadusele laekub tulumaks väljamakstud dividendidelt vaid riigieelarvesse, mitte kohaliku omavalitsuse tulubaasi',
        value: 'tulude-potentsiaalne-laekumine'
    }, {
        title: 'Tulubaasi kasv, kui dividenditulust laekuks 2% maksutulu KOV-i',
        description: '',
        value: 'tulude-potentsiaalne-laekumine-kasv'
    }, {
        title: 'FIT maksutulu suurenemise kalkulaator',
        graphTitle: 'FIT* maksutulu suurenemise kalkulaator',
        description: 'Mängi läbi valla tulubaasi suurenemine. Mitu maksumaksjat aastas valda lisandub? Mitu protsenti suureneb viimsilaste töötasu? *FIT on füüsilise isiku tulumaks.',
        value: 'fit'
    }]
}, {
    name: "Maamaksu laekumise prognoos",
    title: "Maamaksu laekumise prognoos",
    value: "maamaks",
    defaultGraphName: "maamaksu-laekumine"
}, {
    name: "Demograafilised andmed",
    title: "Demograafilised andmed",
    description: "Demograafilised andmed",
    value: "demograafilised",
    defaultGraphName: "demograafilised-andmed-vanus",
    tabs: [
    // {
    //     title: 'Inimeste arvu muutus ajas',
    //     value: 'demograafilised-andmed'
    // },
    {
        title: 'Inimeste arv vanuserühmade kaupa',
        value: 'demograafilised-andmed-vanus'
    }, {
        title: 'Sisse/välja registreerimised',
        value: 'demograafilised-andmed-registreeritud'
    }]
}, {
    name: "Elanike tulude jaotus",
    title: "Elanike tulude jaotus",
    description: "Elanike tulude jaotus",
    value: "tulude-jaotus",
    defaultGraphName: "tulude-jaotus-summa",
    tabs: [{
        title: 'Piirkonna elanike aastatulud',
        value: 'tulude-jaotus-summa'
    }, {
        title: 'Piirkonna maksumaksjate arv',
        value: 'tulude-jaotus-arv'
    }]
}];
// Chart settings
var getGraphSettings = function getGraphSettings(graphName) {
    var settings;
    switch (graphName) {
        case 'tulubaas':
            settings = {
                title: 'Tulude üldine laekumine',
                description: '',
                stacked: true,
                uiConfig: {
                    format: true,
                    graphSelector: [{
                        label: 'Suurimad tuluartiklid',
                        value: 'tulubaas'
                    }, {
                        label: 'Maksutulud',
                        value: 'maksutulud'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].ÜLDINE_TULUDE_LAEKUMINE,
                    label: 'täitmineKassapõhine',
                    group: 'tüüp',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE]
                }
            };
            break;
        case 'maksutulud':
            settings = {
                title: 'Tulude üldine laekumine',
                description: '',
                stacked: true,
                uiConfig: {
                    format: true,
                    graphSelector: [{
                        label: 'Suurimad tuluartiklid',
                        value: 'tulubaas'
                    }, {
                        label: 'Maksutulud',
                        value: 'maksutulud'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].ÜLDINE_TULUDE_LAEKUMINE,
                    label: 'täitmineKassapõhine',
                    group: 'nimi',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE]
                }
            };
            break;
        case 'tulude-laekumine-ajas':
            settings = {
                title: 'Tulude laekumine ajas',
                description: '',
                stacked: true,
                uiConfig: {
                    graphSelector: [{
                        label: 'Brutosissetulek',
                        value: 'tulude-laekumine-ajas'
                    }, {
                        label: 'Maksutulud',
                        value: 'tulude-laekumine-ajas-tax'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMISE_SUMMA,
                    label: 'grupisIsikuid',
                    group: 'vanus',
                    format: FormatNameValues.PEOPLE
                },
                y2: [{
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMISE_SUMMA,
                    label: 'keskmineBrutotulu',
                    renameLabel: 'Keskmine aasta bruto töötasu',
                    format: FormatNameValues.CURRENCY
                }]
            };
            break;
        case 'tulude-laekumine-ajas-tax':
            settings = {
                title: 'Tulude laekumine ajas',
                description: 'Enim on viie aastaga lisandunud 40-49 aastaseid, kes on ka suurimad maksumaksjad.',
                stacked: true,
                uiConfig: {
                    graphSelector: [{
                        label: 'Brutosissetulek',
                        value: 'tulude-laekumine-ajas'
                    }, {
                        label: 'Maksutulud',
                        value: 'tulude-laekumine-ajas-tax'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMISE_SUMMA,
                    label: 'grupisIsikuid',
                    group: 'vanus',
                    format: FormatNameValues.PEOPLE
                },
                y2: [{
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMISE_SUMMA,
                    label: 'brutotulust116',
                    renameLabel: 'Vallale laekuv aastane tulumaks',
                    format: FormatNameValues.CURRENCY
                }]
            };
            break;
        case 'toohoive':
            settings = {
                title: 'Brutosissetulek',
                description: '',
                stacked: true,
                uiConfig: {
                    gender: true,
                    format: true
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].ÜLDISELT_TÖÖTAVAD_INIMESED,
                    label: 'grupisIsikuid',
                    group: 'tulugrupp',
                    format: [FormatNameValues.PEOPLE, FormatNameValues.PERCENTAGE]
                }
            };
            break;
        case 'toohoive-asukoht':
            settings = {
                title: 'Töötamise asukoht',
                description: '',
                uiConfig: {
                    format: true,
                    customCheck: [{
                        label: 'Viimsi vallas ja muljal',
                        value: 'Viimsi vallas ja muljal'
                    }, {
                        label: 'Viimsi vald',
                        value: 'Viimsi vald'
                    }, {
                        label: 'Mujal',
                        value: 'Mujal'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TÖÖTAMISE_ASUKOHT,
                    label: 'erinevaidTootajaid',
                    group: 'asukohaGrupp',
                    format: [FormatNameValues.PEOPLE, FormatNameValues.PERCENTAGE]
                }
            };
            break;
        case 'toohoive-top':
            settings = {
                title: 'Viimsilaste töökohad',
                description: '',
                stacked: true,
                uiConfig: {},
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TOP10_ASUKOHA_PÕHINE,
                    label: 'hõivatudIsikuid',
                    group: 'linnVald',
                    format: FormatNameValues.PERCENTAGE
                }
            };
            break;
        case 'toohoive-emtak':
            settings = {
                title: 'Viimsilaste töövaldkonnad',
                description: '',
                stacked: true,
                uiConfig: {},
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].EMTAK2_PÕHINE,
                    label: 'hõivatudIsikuid',
                    group: 'sektorMkr',
                    format: FormatNameValues.PERCENTAGE,
                    limit: 5
                }
            };
            break;
        case 'tulude-laekumine-palgagrupiti':
            settings = {
                title: 'Tulud tööandja asukoha põhiselt',
                description: 'Töötamise asukoha põhised andmed on kättesaadavad alates 2017. a. Viimati uuendatud: 30.11.2017.',
                stacked: true,
                uiConfig: {
                    gender: true,
                    graphSelector: [{
                        label: 'Vanus',
                        value: 'tulude-laekumine-vanuseruhmiti'
                    }, {
                        label: 'Tööandja asukoht',
                        value: 'tulude-laekumine-palgagrupiti'
                    }],
                    customRadio: [{
                        label: 'Viimsi vald ja mujal',
                        value: 'Viimsi vald ja mujal'
                    }, {
                        label: 'Viimsi vald',
                        value: 'Viimsi vald'
                    }, {
                        label: 'Mujal',
                        value: 'Mujal'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMINE_PALGAGRUPITI,
                    label: 'brutotuludKokku',
                    group: 'tulugrupp',
                    format: FormatNameValues.CURRENCY
                }
            };
            break;
        case 'tulude-laekumine-vanuseruhmiti':
            settings = {
                title: 'Tulude laekumine vanuserühmiti',
                description: '',
                stacked: true,
                uiConfig: {
                    gender: true,
                    graphSelector: [{
                        label: 'Vanus',
                        value: 'tulude-laekumine-vanuseruhmiti'
                    }, {
                        label: 'Tööandja asukoht',
                        value: 'tulude-laekumine-palgagrupiti'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMINE_VANUSERÜHMITI,
                    label: 'brutotulust116',
                    group: 'vanus',
                    format: FormatNameValues.CURRENCY
                }
            };
            break;
        case 'tulude-potentsiaalne-laekumine':
            settings = {
                title: 'Viimsi elanikele makstud dividendid*',
                description: '*Vastavalt seadusele laekub tulumaks väljamakstud dividendidelt vaid riigieelarvesse, mitte kohaliku omavalitsuse tulubaasi',
                uiConfig: {},
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].DIVIDENDI_TULU_ÜLDISELT,
                    label: 'dividendideSumma',
                    renameLabel: 'Dividendide summa',
                    format: FormatNameValues.CURRENCY
                },
                y2: [{
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].DIVIDENDI_TULU_SAAJAID_ARVULISELT,
                    label: 'erinevaidFüüsilisiIsikuid',
                    group: 'sugu',
                    format: FormatNameValues.PEOPLE
                }]
            };
            break;
        case 'tulude-potentsiaalne-laekumine-kasv':
            settings = {
                title: 'Tulubaasi kasv, kui dividenditulust laekuks 2% maksutulu KOV-i',
                description: '',
                uiConfig: {
                    gender: true
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUBAASI_KASV,
                    label: 'tulubaasiKasv',
                    group: 'vanus',
                    format: FormatNameValues.CURRENCY
                }
            };
            break;
        case 'maamaksu-laekumine':
            settings = {
                title: 'Maamaksu laekumise prognoos sihtotstarbe põhiselt',
                description: '',
                uiConfig: {
                    format: true,
                    graphSelector: [{
                        label: 'Otstarve',
                        value: 'maamaksu-laekumine'
                    }, {
                        label: 'Asukoht',
                        value: 'maamaksu-laekumine-asukoht'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL,
                    label: 'maamaks',
                    group: 'sihtotstarve',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE],
                    limit: 3
                }
            };
            break;
        case 'maamaksu-laekumine-asukoht':
            settings = {
                title: 'Maamaksu laekumise prognoos asukoha põhiselt',
                description: '',
                uiConfig: {
                    format: true,
                    graphSelector: [{
                        label: 'Otstarve',
                        value: 'maamaksu-laekumine'
                    }, {
                        label: 'Asukoha',
                        value: 'maamaksu-laekumine-asukoht'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL,
                    label: 'maamaks',
                    group: 'nimi',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE],
                    limit: 3
                }
            };
            break;
        case 'demograafilised-andmed':
            settings = {
                title: 'Inimeste arvu muutus ajas',
                description: '',
                uiConfig: {
                    gender: true
                },
                x: {
                    label: 'seisuAasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].INIMESTE_ARVU_MUUTUS_AJAS,
                    label: 'elanike',
                    renameLabel: 'Elanike',
                    format: FormatNameValues.PEOPLE
                }
            };
            break;
        case 'demograafilised-andmed-vanus':
            settings = {
                title: 'Inimeste arv vanuserühmade kaupa',
                description: '',
                uiConfig: {
                    gender: true
                },
                x: {
                    label: 'seisuAasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].INIMESED_VANUSERÜHMITI,
                    label: 'suguVanusegrupisKokku',
                    group: 'vanuseGrupp',
                    format: FormatNameValues.PEOPLE
                }
            };
            break;
        case 'demograafilised-andmed-registreeritud':
            settings = {
                title: 'Sisse/välja registreerimised',
                description: '',
                uiConfig: {
                    customRadio: [{
                        label: 'Viimsisse registreerunud',
                        value: 'uuedRegistreerunudInimesed'
                    }, {
                        label: 'Viimsist lahkunud',
                        value: 'väljaRegistreerunud'
                    }],
                    customCheck: [{
                        label: 'Sündinud Viimsis',
                        value: 'uutestRegistreerunutestSündinudVv'
                    }, {
                        label: 'Mujalt tulnud',
                        value: 'uutestRegistreerunutestVäljastTulnud'
                    }]
                },
                x: {
                    label: 'seisuAasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].SISSE_VÄLJA_REGISTREERIMISED,
                    label: 'inimesed',
                    renameLabel: 'Isikuid',
                    format: FormatNameValues.PEOPLE
                }
            };
            break;
        case 'tulude-jaotus-summa':
            settings = {
                title: 'Piirkonna elanike palga- ja dividenditulud',
                description: '',
                stacked: true,
                uiConfig: {
                    customCheck: [{
                        label: 'Pot. dividenditulud',
                        value: 'Pot. dividenditulud'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'summa',
                    group: 'type',
                    format: FormatNameValues.CURRENCY
                },
                y2: [{
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'palgatulu1116',
                    renameLabel: 'Valda laekuv tulumaks',
                    format: FormatNameValues.CURRENCY
                }, {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'dividenditulu2',
                    renameLabel: 'Pot. valda laekuv dividenditulu 2%',
                    format: FormatNameValues.CURRENCY
                }]
            };
            break;
        case 'tulude-jaotus-arv':
            settings = {
                title: 'Inimeste arv',
                description: '',
                stacked: true,
                uiConfig: {
                    customCheck: [{
                        label: 'Pot. dividenditulud',
                        value: 'Pot. dividenditulud'
                    }]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'summa',
                    group: 'type',
                    format: FormatNameValues.PEOPLE
                },
                y2: [{
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'palgatulu1116',
                    renameLabel: 'Valda laekuv tulumaks',
                    format: FormatNameValues.CURRENCY
                }, {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'dividenditulu2',
                    renameLabel: 'Valda laekuv potentsiaalne dividenditulu',
                    format: FormatNameValues.CURRENCY
                }]
            };
            break;
        case 'fit':
            settings = {
                title: '',
                description: '',
                uiConfig: {
                    gender: false,
                    format: false,
                    customCheck: [{
                        label: 'Pot. dividenditulud',
                        value: 'Pot. dividenditulud'
                    }]
                },
                x: {
                    label: 'year'
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].TULUDE_LAEKUMISE_SUMMA,
                    label: 'tax',
                    group: 'type',
                    format: FormatNameValues.CURRENCY
                }
            };
            break;
        default:
            settings = {
                title: '',
                description: '',
                uiConfig: {
                    customCheck: [{
                        label: 'Pot. dividenditulud',
                        value: 'Pot. dividenditulud'
                    }]
                },
                x: {
                    label: ''
                },
                y: {
                    graphName: __WEBPACK_IMPORTED_MODULE_0__api_generated_api_types__["a" /* GraphNameValues */].ÜLDINE_TULUDE_LAEKUMINE,
                    label: '',
                    format: null
                }
            };
            break;
    }
    return settings;
};
// bubble data for landing page
var BubblesData = [{
    priority: 1,
    size: 'xl',
    url: '/graphs/viimsi/kokku/tulud/tulubaas',
    contents: [{
        id: 'tulubaas',
        text: 'Viimsi tulud eelarves',
        value: null
    }]
}, {
    priority: 2,
    size: 'lg',
    url: '/graphs/viimsi/kokku/tulud-ajas/tulude-laekumine-ajas',
    contents: [{
        id: 'füüsiliseIsikuTulumaks',
        text: 'Füüsilise isiku tulumaks',
        value: null
    }]
}, {
    priority: 3,
    size: 'xs-alt',
    url: '/graphs/viimsi/kokku/demograafilised/demograafilised-andmed-vanus',
    contents: [{
        id: 'maksumaksjaid',
        text: 'maksumaksjat',
        value: null
    }, {
        id: 'elanikeArv',
        text: 'elanikku',
        value: null
    }]
}, {
    priority: 4,
    size: 'sm',
    url: '/graphs/viimsi/kokku/toohoive/toohoive',
    contents: [{
        id: null,
        text: 'Viimsi inimeste sissetulekud',
        value: '€'
    }]
}, {
    priority: 5,
    size: 'md',
    url: '/graphs/viimsi/kokku/tulud-ajas/tulude-laekumine-ajas',
    contents: [{
        id: 'viimsiKeskmineBrutosissetulek',
        text: 'Töötavate viimsilaste keskmine brutotöötasu',
        value: null
    }]
}, {
    priority: 6,
    size: 'xs',
    url: '/graphs/viimsi/kokku/tulude-potentsiaal/tulude-potentsiaalne-laekumine',
    contents: [{
        id: 'potensiaalneDividendiTulumaks',
        text: 'Võimalikud tuluallikad',
        value: null
    }]
}];
// Graph Selectors (for radioboxes)
var AgeGroups = [{ label: 'kuni 18', name: 'kuni 18' }, { label: '18-29', name: '18-29' }, { label: '30-39', name: '30-39' }, { label: '40-49', name: '40-49' }, { label: '50-59', name: '50-59' }, { label: '60-69', name: '60-69' }, { label: '70+', name: '70+' }];
var viewMode = [{ label: 'arvuline', value: 'sum' }, { label: 'Protsentuaalne', value: 'ratio' }];

/***/ }),

/***/ "O69B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = c3LongRound;
/* unused harmony export c3LongRoundMin */
/* unused harmony export c3MinMax */
/* unused harmony export c3DataMaxValue */
/* unused harmony export getY2 */
function c3LongRound(n) {
    if (n <= 1) {
        return n;
    }
    if (n <= 10) {
        return Math.ceil(n / 10) * 10;
    }
    if (n <= 100) {
        return Math.ceil(n / 10) * 10;
    }
    if (n <= 1000) {
        return Math.ceil(n / 10) * 10;
    }
    if (n <= 10000) {
        return Math.ceil(n / 1000) * 1000;
    }
    if (n <= 100000) {
        return Math.ceil(n / 1000) * 1000;
    }
    if (n <= 1000000) {
        return Math.ceil(n / 100000) * 100000;
    }
    if (n <= 10000000) {
        return Math.ceil(n / 1000000) * 1000000;
    }
    if (n <= 100000000) {
        return Math.ceil(n / 10000000) * 10000000;
    }
    if (n <= 1000000000) {
        return Math.ceil(n / 10000000) * 10000000;
    }
    if (n <= 10000000000) {
        return Math.ceil(n / 10000000) * 10000000;
    }
    return n;
}
function c3LongRoundMin(n) {
    if (n <= 1) {
        return n;
    }
    if (n <= 10) {
        return Math.ceil(n / 10) * 10 - 10;
    }
    if (n <= 100) {
        return Math.ceil(n / 10) * 10 - 10;
    }
    if (n <= 1000) {
        return Math.ceil(n / 10) * 10 - 10;
    }
    if (n <= 10000) {
        return Math.ceil(n / 1000) * 1000 - 1000;
    }
    if (n <= 100000) {
        return Math.ceil(n / 1000) * 1000 - 1000;
    }
    if (n <= 1000000) {
        return Math.ceil(n / 100000) * 100000 - 100000;
    }
    if (n <= 10000000) {
        return Math.ceil(n / 1000000) * 1000000 - 1000000;
    }
    if (n <= 100000000) {
        return Math.ceil(n / 10000000) * 10000000 - 10000000;
    }
    if (n <= 1000000000) {
        return Math.ceil(n / 10000000) * 10000000 - 10000000;
    }
    if (n <= 10000000000) {
        return Math.ceil(n / 10000000) * 10000000 - 10000000;
    }
    return n;
}
function c3MinMax(n) {
    return [Math.min.apply(Math, n), Math.max.apply(Math, n)];
}
function c3DataMaxValue(n, type) {
    if (type === 'percentage') {
        return 1;
    }
    if (type === 'percentageLimit') {
        return Math.max.apply(Math, n);
    }
    if (type === 'bar') {
        var numberData = n.map(function (row) {
            return row.filter(function (item) {
                return typeof item !== 'string';
            });
        });
        return c3LongRound(Math.max.apply(Math, numberData.map(function (item) {
            return Math.max.apply(Math, item);
        })));
    }
    var filteredArray = n.map(function (item) {
        return item.filter(function (childItem) {
            return typeof childItem !== 'string';
        });
    });
    return c3LongRound(Math.max.apply(Math, filteredArray.reduce(function (a, b) {
        return a.map(function (x, i) {
            return x + b[i];
        });
    })));
}
function getY2(data, format, options) {
    var axes = {};
    var types = {};
    var y2;
    if (data.length) {
        axes = data.reduce(function (acc, curr) {
            acc[curr[0]] = 'y2';
            return acc;
        }, {});
        types = data.reduce(function (acc, curr) {
            acc[curr[0]] = 'line';
            return acc;
        }, {});
        var filteredData = data.reduce(function (acc, curr) {
            return acc.concat(curr.filter(function (item) {
                return typeof item === 'number';
            }));
        }, []);
        var y2MinMax = c3MinMax(filteredData);
        var min = filteredData.length === 1 ? 0 : c3LongRoundMin(y2MinMax[0]);
        if (options && options.fromZero) {
            min = 0;
        }
        var max = c3LongRound(y2MinMax[1]);
        y2 = {
            show: true,
            padding: { top: 0, bottom: 0 },
            min: min,
            max: max,
            tick: {
                format: format,
                count: 5
            }
        };
    }
    return { axes: axes, types: types, y2: y2 };
}

/***/ }),

/***/ "PncN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_landing_vue__ = __webpack_require__("DncG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e77dfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_landing_vue__ = __webpack_require__("AlLZ");
function injectStyle (ssrContext) {
  __webpack_require__("b0Ya")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14e77dfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e77dfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q0L8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section fallback"},[_c('section',{staticClass:"section__content fallback__content"},[_c('img',{staticClass:"fallback__logo",attrs:{"src":__webpack_require__("25eS"),"alt":"404 logo"}}),_vm._v(" "),_c('h1',{staticClass:"fallback__title"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"fallback__text"},[_vm._v("Oi-oi! Paistab, et seda graafikut ei leitud.")]),_vm._v(" "),_c('router-link',{staticClass:"btn",attrs:{"to":'/'}},[_vm._v("\n            Esilehele\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "STPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-autocomplete__item"},[_c('span',[_vm._v(_vm._s(_vm.item ? _vm.item.name : ''))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TBSv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UaUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__("EOM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_c3__ = __webpack_require__("g1pc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_c3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_c3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3__ = __webpack_require__("Za4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__radiobox_vue__ = __webpack_require__("lxHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_c3_extensions__ = __webpack_require__("O69B");






var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};







var Chart = /** @class */function (_super) {
    __extends(Chart, _super);
    function Chart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slotValue = null;
        _this.legends = [];
        _this.limitLegend = 3;
        _this.ET = __WEBPACK_IMPORTED_MODULE_10_d3___default.a.locale({
            "decimal": ".",
            "thousands": " ",
            "grouping": [3],
            "currency": ["", "€"],
            "dateTime": "%a %b %e %X %Y",
            "date": "%m/%d/%Y",
            "time": "%H:%M:%S",
            "periods": ["AM", "PM"],
            "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });
        return _this;
    }
    Object.defineProperty(Chart.prototype, "getGraphNameFromUrl", {
        get: function get() {
            return this.$route.params.graphName;
        },
        enumerable: true,
        configurable: true
    });
    Chart.prototype.onPersonChanged = function (val, oldVal) {
        if (val) {
            var self_1 = this;
            this.chart = this.generateChart(val);
            val.y2.data = val.y2.data || [];
            var loadedData = val.y.data.concat(val.y2.data);
            this.chart.load({
                columns: loadedData
            });
            var legendsBar = val.y.data.map(function (item) {
                return item[0];
            }).map(function (item) {
                return {
                    label: item,
                    color: self_1.chart.color(item),
                    type: 'bar'
                };
            });
            var legendsLine = val.y2.data.map(function (item) {
                return item[0];
            }).map(function (item) {
                return {
                    label: item,
                    color: self_1.chart.color(item),
                    type: 'line'
                };
            });
            this.legends = legendsBar.concat(legendsLine);
        }
    };
    Chart.prototype.mounted = function () {
        this.slotValue = this.$slots.default;
    };
    /*
        Generate chart with default settings and return an instance of it
        in order to show and hide datasets on demand
    */
    Chart.prototype.generateChart = function (config) {
        var altConfig = {
            years: config.x.map(function (item) {
                return item.label;
            }),
            dataY: config.y.data,
            dataYFormat: config.y.format,
            dataY2: config.y2.data || [],
            dataY2Format: config.y2.format,
            dataY2Options: config.y2.options,
            stacked: config.y.stacked,
            type: config.y.type || 'bar'
        };
        var chartConfig = this.getGeneralSumConfig(altConfig, config);
        chartConfig.bindto = '.chart__content';
        return __WEBPACK_IMPORTED_MODULE_9_c3___default.a.generate(chartConfig);
    };
    Chart.prototype.getGeneralSumConfig = function (config, fullConfig) {
        // NEW
        var dataY = fullConfig.y.data;
        var dataY2 = fullConfig.y2.data || [];
        //END NEW
        // let format2 = this.getTickFormat(config.dataY2Format);
        // let group;
        // let dataColors: any = {};
        // const colorPalette = ['#357DBA', '#A5C866', '#DF673D', '#67C4EF', '#FCBA41', '#73A580', '#97D2FB', '#DD7676', '#A4B0F5', '#ECCBD9', '#B8529E', '#16DB93'];
        // if(config.stacked) {
        //     group = [ config.dataY.map((item: any) => item[0]) ];
        // }
        // config.dataY.map((item: any) => item[0]).forEach((item: any, index: number) => {
        //     if(colorPalette[index]) {
        //         dataColors[item] = colorPalette[index];
        //     }
        // });
        // const {axes: newAxes, types: newTypes, y2: newY2} = getY2(config.dataY2, format2, config.dataY2Options);
        /**
         * Chartconfig DATA
         */
        // Custom Styles
        var general = {
            legend: { show: false },
            transition: { duration: 300 },
            grid: { y: { show: true } },
            padding: { top: 10, right: 140, left: 140 },
            color: { pattern: ['#357DBA', '#A5C866', '#DF673D', '#67C4EF', '#FCBA41', '#73A580', '#97D2FB', '#DD7676', '#A4B0F5', '#ECCBD9', '#B8529E', '#16DB93'] }
        };
        // Set values to zero for route change animation. Correct values will be added via @Watch('config', (... look above)
        var initialData = dataY.concat(dataY2).map(function (child) {
            return child.map(function (grandchild) {
                return typeof grandchild === 'number' ? 0 : grandchild;
            });
        });
        // Multidimensional array, with each element containing an array consisting of a datum name and associated data values.
        // ex: [ ['label', 0, 0], ['label', 0, 0] ]
        var columns = initialData;
        // Set y axis the data related to. y and y2 can be used.
        // ex: {Tulubaasi kasv: "y2"}
        var axes = dataY2.reduce(function (acc, curr) {
            acc[curr[0]] = 'y2';
            return acc;
        }, {});
        //Set chart type at once: line, bar, pie, spline, step, area, area-spline, area-step, scatter, donut, gauge
        var type = config.type || 'bar';
        // Set chart type for each data. (overwrites type)
        // ex: { Saadavad toetused tegevuskuludeks: "bar", Tulubaasi kasv:"line" }
        var types = dataY2.reduce(function (acc, curr) {
            acc[curr[0]] = 'line';
            return acc;
        }, {});
        // Set groups for the data for stacking.
        // [['Maamaks', 'Reklaamimaks']]
        var groups = config.stacked ? [dataY.map(function (item) {
            return item[0].toString();
        })] : [];
        // Combine data
        var data = {
            columns: columns,
            axes: axes,
            type: type,
            types: types,
            groups: groups,
            order: null // order based on incomed data
        };
        /**
         * Chartconfig AXIS
         */
        // Chartconfig AXIS: X
        // Array that includes category names in string displayed on X axis
        // ex: [2013, 2014, ...]
        var categories = config.years;
        var x = {
            type: 'category',
            categories: categories
        };
        // Set formatter for y axis tick text.
        // ex: (val) => val €
        var yFormat = this.getTickFormat;
        // Chartconfig AXIS: Y
        var y = {
            min: 0,
            max: this.getMaxValue(config.dataYFormat, config.dataY),
            tick: {
                format: yFormat(config.dataYFormat),
                count: 5
            },
            padding: { top: 0, bottom: 0 }
        };
        // Chartconfig AXIS: Y2
        var y2 = {
            show: config.dataYFormat !== 'percentage' && config.dataY2.length,
            min: 0,
            max: this.getMaxValue(config.dataY2Format, config.dataY2, true),
            tick: {
                format: yFormat(config.dataY2Format),
                count: 5
            },
            padding: { top: 0, bottom: 0 }
        };
        var axis = {
            x: x,
            y: y,
            y2: y2
        };
        // ChartConfig Tooltip
        var tooltip = {
            grouped: false,
            format: {
                title: function title(index) {
                    if (config.dataYFormat === 'percentage') {
                        return '';
                    }
                    if (fullConfig && fullConfig.x[index] && fullConfig.x[index].total) {
                        return 'Kokku: ' + yFormat(config.dataYFormat)(+fullConfig.x[index].total.toFixed());
                    }
                    return '';
                }
            }
        };
        var chartConfigNew = __assign({}, general, { data: data,
            axis: axis,
            tooltip: tooltip });
        return chartConfigNew;
        // const chartConfig: c3.ChartConfiguration = {
        //     data: {
        //         columns: initialColumns,
        //         axes,
        //         type: type,
        //         types,
        //         groups: group,
        //         order: null
        //     },
        //     legend: {
        //         show: false
        //     },
        //     tooltip: {
        //         grouped: false,
        //         format: {
        //             title: (index: any) => {
        //                 if(config.dataYFormat === 'percentage') { return ''; }
        //                 if(fullConfig && fullConfig.x[index] && fullConfig.x[index].total) {
        //                     return 'Kokku: ' + format(fullConfig.x[index].total.toFixed())
        //                 }
        //                 return '';
        //             }
        //         }
        //     },
        //     axis: {
        //         x: {
        //             type: 'category',
        //             categories: config.years,
        //         },
        //         y: {
        //             padding: { top: 0, bottom: 0},
        //             min: 0,
        //             max: config.dataYFormat === 'percentage' ?
        //                     this.getDataMaxValue(config, 'percentage') :
        //                 (config.type === 'bar' && !config.stacked) ?
        //                     this.getDataMaxValue(config, 'bar') :
        //                     this.getDataMaxValue(config), // we cant use the head value only for bar chart that is not stacked,
        //                                                   // since it's max value is dependant on each individual bar
        //             tick: {
        //                 format: format,
        //                 count: 5
        //             }
        //         },
        //         y2
        //     },
        //     padding: {
        //         top: 10,
        //         right: 140,
        //         left: 140
        //     },
        //     grid: {
        //         y: {
        //             show: true
        //         }
        //     },
        //     color: {
        //         pattern: colorPalette
        //     },
        //     transition: {
        //         duration: 300
        //     }
        // };
        // return chartConfig;
    };
    Chart.prototype.getMaxValue = function (format, data, y2) {
        if (y2 === void 0) {
            y2 = false;
        }
        if (!format) return 0;
        switch (format) {
            case 'percentage':
                if (!y2) return 1; // 1 === 100%
            default:
                // 1) remove labels
                // 2) SUM matrix array to single dimensional array
                var numberArray = data.map(function (children) {
                    return children.reduce(function (acc, curr) {
                        return typeof curr !== 'string' ? acc.concat([curr]) : acc;
                    }, []);
                }).reduce(function (a, b) {
                    return a.map(function (x, i) {
                        return x + b[i];
                    });
                });
                return Object(__WEBPACK_IMPORTED_MODULE_12__core_c3_extensions__["a" /* c3LongRound */])(Math.max.apply(Math, numberArray));
        }
    };
    // private getDataMaxValue(config: any, type?: string): number {
    //     let maxValue = 0;
    //     switch(type) {
    //         case 'percentage':
    //             maxValue = 1;
    //             break;
    //         case 'bar':
    //             let numberData = config.dataY.map((row: any) => {
    //                 return row.filter((item: any) => typeof item !== 'string');
    //             });
    //             maxValue = Math.max(...numberData.map((item: any) => Math.max(...item)));
    //             maxValue = c3LongRound(maxValue)
    //             break;
    //         default:
    //             let filteredArray = config.dataY.map((item: any) => item.filter((childItem: any) => typeof childItem !== 'string'));
    //             maxValue = Math.max(...filteredArray.reduce((a: any, b: any) => a.map((x: any, i: any) => x + b[i])));
    //             maxValue = c3LongRound(maxValue)
    //     }
    //     return maxValue;
    // }
    Chart.prototype.getTickFormat = function (key) {
        var _this = this;
        switch (key) {
            case 'currency':
                return function (d) {
                    return d >= 1000000 ? Math.round(d / 1000000 * 100) / 100 + " mln \u20AC" : _this.ET.numberFormat(',')(Math.round(d)) + " \u20AC";
                };
            case 'percentage':
                return __WEBPACK_IMPORTED_MODULE_10_d3___default.a.format("%");
            case 'people':
                return function (d) {
                    return _this.ET.numberFormat(',')(Math.round(d)) + " inimest";
                };
            default:
                return null;
        }
    };
    Chart.prototype.onTypeChanged = function (type) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].gtm.trackEvent({ category: 'Graph', action: 'change', label: 'Type', value: type });
        this.$emit('onTypeChanged', type);
    };
    Chart.prototype.onGenderChanged = function (gender) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].gtm.trackEvent({ category: 'Graph', action: 'change', label: 'Gender', value: gender });
        this.$emit('onGenderChanged', gender);
    };
    Chart.prototype.toggleLegendLimit = function () {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].gtm.trackEvent({ category: 'Graph', action: 'click', label: 'Legend toggle' });
        this.limitLegend = this.limitLegend === 3 ? this.limitLegend = 10000 : 3;
    };
    Chart.prototype.legendMouseOver = function (label) {
        this.chart.focus(label);
    };
    Chart.prototype.legendMouseOut = function (label) {
        this.chart.revert();
    };
    __decorate([Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('config', { immediate: true, deep: true })], Chart.prototype, "onPersonChanged", null);
    Chart = __decorate([__WEBPACK_IMPORTED_MODULE_7_vue_class_component___default()({
        props: ['description', 'config', 'showType', 'type', 'showGender', 'gender', 'slotAsLast', 'wrapSettings'],
        components: {
            radiobox: __WEBPACK_IMPORTED_MODULE_11__radiobox_vue__["a" /* default */]
        }
    })], Chart);
    return Chart;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (Chart);
;

/***/ }),

/***/ "VbKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubble_vue__ = __webpack_require__("B0qP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbb0b458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bubble_vue__ = __webpack_require__("y3WP");
function injectStyle (ssrContext) {
  __webpack_require__("TBSv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbb0b458"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbb0b458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VtMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts__header"},[(_vm.title)?_c('h1',{staticClass:"charts__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"charts__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WElR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v_autocomplete_item_vue__ = __webpack_require__("t2/f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_244e10fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v_autocomplete_item_vue__ = __webpack_require__("STPV");
function injectStyle (ssrContext) {
  __webpack_require__("6ywT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-244e10fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v_autocomplete_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_244e10fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v_autocomplete_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WcGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"radiobox"},[_c('span',{staticClass:"radiobox__input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.radioValue),expression:"radioValue"}],attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm._q(_vm.radioValue,_vm.value)},on:{"change":function($event){_vm.radioValue=_vm.value}}}),_vm._v(" "),_c('span')]),_vm._v(" "),_c('span',{staticClass:"radiobox__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "arfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");


var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();

var App = /** @class */function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return App;
}(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (App);
;

/***/ }),

/***/ "b0Ya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c5Mg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__("+4Ht");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b469499_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("Q0L8");
function injectStyle (ssrContext) {
  __webpack_require__("r/i1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b469499"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b469499_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cqHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormatNameValues; });
var FormatNameValues;
(function (FormatNameValues) {
    FormatNameValues.CURRENCY = 'currency';
    FormatNameValues.PERCENTAGE = 'percentage';
    FormatNameValues.PEOPLE = 'people';
    FormatNameValues.NULL = null;
})(FormatNameValues || (FormatNameValues = {}));

/***/ }),

/***/ "d/t5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dCQR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e1wJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_v_autocomplete_item_vue__ = __webpack_require__("WElR");





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};



var Selectbox = /** @class */function (_super) {
    __extends(Selectbox, _super);
    function Selectbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.autocompleteItemTemplate = __WEBPACK_IMPORTED_MODULE_7__components_v_autocomplete_item_vue__["a" /* default */];
        _this.autocompleteInputAttrs = { readonly: true, class: 'v-autocomplete-input v-autocomplete-input--select' };
        _this.queryOptions = [];
        _this.autocompleteModel = null;
        return _this;
    }
    Selectbox.prototype.mounted = function () {
        var _this = this;
        this.queryOptions = this.options.filter(function (option) {
            return option !== _this.value;
        });
        this.autocompleteModel = this.value;
    };
    Object.defineProperty(Selectbox.prototype, "selectModel", {
        get: function get() {
            return this.value.value;
        },
        set: function set(val) {
            this.onSelectChange(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Selectbox.prototype, "getOptionsWithoutCurrent", {
        get: function get() {
            var _this = this;
            return this.options.filter(function (option) {
                return option !== _this.value;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Selectbox.prototype, "isMobile", {
        get: function get() {
            return window.outerWidth < 425; // only check during component render
        },
        enumerable: true,
        configurable: true
    });
    /*
        Return label for autocomplete input
     */
    Selectbox.prototype.getAutocompleteValueLabel = function (item) {
        return item ? item.name : '';
    };
    /*
        Filter autocomplete suggestion based on typed text
     */
    Selectbox.prototype.updateAutocomplete = function () {
        var _this = this;
        this.queryOptions = this.options.filter(function (option) {
            return option !== _this.value;
        });
    };
    /*
        When selection is performed
     */
    Selectbox.prototype.onSelectChange = function (newVal) {
        // skip running this when component loads
        if (this.isMobile || !this.isMobile && newVal !== this.autocompleteModel) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].gtm.trackEvent({
                category: 'Graph',
                action: 'click',
                label: 'Dropdown click',
                value: newVal
            });
            document.activeElement.blur(); // blur input when selection is done(hack for using a keyboard for selection)
            this.$emit('onSelectChanged', this.isMobile ? this.options.find(function (option) {
                return option.value === newVal;
            }) : newVal);
        }
        this.updateAutocomplete();
    };
    Selectbox = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
        props: ['options', 'value'],
        components: {}
    })], Selectbox);
    return Selectbox;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (Selectbox);
;

/***/ }),

/***/ "eFYS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJtW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectbox"},[(_vm.isMobile)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectModel),expression:"selectModel"}],staticClass:"selectbox__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectModel=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{attrs:{"hidden":_vm.selectModel === option.value},domProps:{"value":option.value}},[_vm._v(_vm._s(_vm.getAutocompleteValueLabel(option)))])})):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('v-autocomplete',{attrs:{"items":_vm.queryOptions,"input-attrs":_vm.autocompleteInputAttrs,"get-label":_vm.getAutocompleteValueLabel,"component-item":_vm.autocompleteItemTemplate,"wait":0,"min-len":0,"auto-select-one-item":false},on:{"item-selected":_vm.onSelectChange},model:{value:(_vm.autocompleteModel),callback:function ($$v) {_vm.autocompleteModel=$$v},expression:"autocompleteModel"}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"selectbox__icon el-icon-arrow-down"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j45X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdNR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_landing_vue__ = __webpack_require__("PncN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_graph_vue__ = __webpack_require__("9YiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_404_vue__ = __webpack_require__("c5Mg");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Esileht',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_landing_vue__["a" /* default */]
    }, {
        path: '/graphs/:area/:village/:section/:graphName',
        name: 'Tulud',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_graph_vue__["a" /* default */]
    }, {
        path: '*',
        name: '404',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_404_vue__["a" /* default */]
    }]
}));

/***/ }),

/***/ "kqyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};


var RadioBox = /** @class */function (_super) {
    __extends(RadioBox, _super);
    function RadioBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioBox = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
        props: ['name', 'currentValue', 'value', 'label'],
        computed: {
            radioValue: {
                get: function get() {
                    return this.$props.currentValue;
                },
                set: function set() {
                    this.$emit('change', this.$props.value);
                }
            }
        }
    })], RadioBox);
    return RadioBox;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (RadioBox);

/***/ }),

/***/ "lxHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiobox_vue__ = __webpack_require__("kqyw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384145ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radiobox_vue__ = __webpack_require__("WcGF");
function injectStyle (ssrContext) {
  __webpack_require__("yai+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-384145ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiobox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384145ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radiobox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ne3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__ = __webpack_require__("E8ca");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79838568_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("vG0C");
function injectStyle (ssrContext) {
  __webpack_require__("iJtW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79838568"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79838568_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "plmt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__ = __webpack_require__("UaUf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099c8ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__ = __webpack_require__("877Q");
function injectStyle (ssrContext) {
  __webpack_require__("eFYS")
  __webpack_require__("j45X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-099c8ea9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099c8ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r/i1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t2/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};


var AutocompleteItem = /** @class */function (_super) {
    __extends(AutocompleteItem, _super);
    function AutocompleteItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutocompleteItem = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
        props: ['item', 'searchText']
    })], AutocompleteItem);
    return AutocompleteItem;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (AutocompleteItem);

/***/ }),

/***/ "tqXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var ApiClient = /** @class */function () {
    function ApiClient() {
        // public fetch = require("fetch-cookie/node-fetch")(require('node-fetch'));
        this.hostname = "";
    }
    ApiClient.prototype.execute = function (method, request) {
        if (request === void 0) {
            request = {};
        }
        var init = {
            method: 'post',
            body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(request, null, 2),
            credentials: "same-origin"
        };
        return fetch(this.hostname + "/api/rpc/" + method, init).then(function (res) {
            return res.json();
        }).then(function (result) {
            // console.log(`${method} request:`);
            // console.log(init.body);
            if (result.ok) {
                // console.log(`${method} response:`);
                // console.log(JSON.stringify(result.response, null, 2));
                return result.response;
            } else {
                // console.error(`${method} problem:`);
                // console.error(JSON.stringify(result.problem, null, 2));
                throw result.problem;
            }
        });
    };
    return ApiClient;
}();


/***/ }),

/***/ "uW5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);





var __extends = this && this.__extends || function () {
    var extendStatics = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, key, r), r;
};


var ChartHeader = /** @class */function (_super) {
    __extends(ChartHeader, _super);
    function ChartHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartHeader = __decorate([__WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
        props: ['title', 'description']
    })], ChartHeader);
    return ChartHeader;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]);
/* harmony default export */ __webpack_exports__["a"] = (ChartHeader);

/***/ }),

/***/ "vG0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox"},[_c('span',{staticClass:"checkbox__input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.val,"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,_vm.val)>-1:(_vm.checked)},on:{"change":[function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.val,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}},_vm.onChange]}}),_vm._v(" "),_c('span')]),_vm._v(" "),_c('span',{staticClass:"checkbox__label"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vag9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x35b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("kdNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gtm__ = __webpack_require__("Sl4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_find__ = __webpack_require__("0K64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_array_fill__ = __webpack_require__("89K5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_object_assign__ = __webpack_require__("kLF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_fn_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_promise__ = __webpack_require__("SCKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_fn_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_whatwg_fetch__ = __webpack_require__("rplX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_icon_css__ = __webpack_require__("d/t5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_autocomplete__ = __webpack_require__("HpzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_autocomplete__);









 // only include the icon css

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_v_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_gtm___default.a, { vueRouter: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */] }
});

/***/ }),

/***/ "y3WP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bubbleRef",staticClass:"bubble",class:' bubble--' + _vm.bubble.priority + (_vm.bubble.size ? ' bubble--' + _vm.bubble.size : '')},[_c('router-link',{staticClass:"bubble__container",attrs:{"to":_vm.bubble.url},nativeOn:{"click":function($event){_vm.bubbleClick(_vm.bubble.url)}}},[_c('p',{staticClass:"bubble__content",class:{'bubble__content--loaded': _vm.minimumTimePassed && _vm.scaleAdjusted}},[_c('span',{ref:"bubbleHeading",staticClass:"bubble__value"},[_vm._v(_vm._s(_vm.bubble.contents[0].value))]),_vm._v(" "),_c('span',{ref:"bubbleText",staticClass:"bubble__text"},[_vm._v(_vm._s(_vm.bubble.contents[0].text))]),_vm._v(" "),(_vm.bubble.contents[1])?_c('span',{ref:"bubbleHeading",staticClass:"bubble__value bubble__value--2"},[_vm._v(_vm._s(_vm.bubble.contents[1].value))]):_vm._e(),_vm._v(" "),(_vm.bubble.contents[1])?_c('span',{ref:"bubbleText",staticClass:"bubble__text"},[_vm._v(_vm._s(_vm.bubble.contents[1].text))]):_vm._e()]),_vm._v(" "),_c('i',{staticClass:"bubble__loader el-icon-loading",class:{'bubble__loader--loading': _vm.minimumTimePassed && !_vm.scaleAdjusted}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yai+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zzif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["x35b"]);


// WEBPACK FOOTER //
// static/js/app.31f2cb8f5d311dad073f.js